import React, { useState, useEffect } from "react";
import axios from "axios";
import DotLoader from "react-spinners/DotLoader";

export default function Home() {
  const urlParams = new URLSearchParams(window.location.search);
  const [customerData, setCustomerData] = useState([]);
  const [tripData, setTripData] = useState([])
  const [customerID, setCustomerID] = useState(urlParams.get("customerID"));
  const [customerTempData, setCustomerTempData] = useState([]);
  const [search, setSearch] = useState("");
  useEffect(() => {

    // Check if the object has key
    function containsKey(array, keyToCheck) {
      for (const obj of array) {
        if (obj.hasOwnProperty(keyToCheck)) {
          return obj; // Found the key
        }
      }
      return false; // Key not found
    }

    const url =
      "https://n8n.arbatravel.com/webhook/c42a7ae7-a29b-4d7e-8cc2-1a837e2b3fae?custid=";
    axios
      .get(url + customerID)
      .then((response) => {
        setCustomerData(containsKey(response.data, "person").person[0]);
        setCustomerTempData(containsKey(response.data, "person").person[0]);
        setTripData(containsKey(response.data, "trip").trip.json)        
        console.log(containsKey(response.data, "person").person[0]);
        console.log(containsKey(response.data, "trip").trip.json)
        if(!isWithin60Days(containsKey(response.data, "trip").trip.json.departdate)){
          window.alert("Your trip is more than 60 days away, PDF details might not be accurate");
        }
      })
      .catch((error) => {
        console.log(error);
      });

    return () => {};
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    setSearch(e.target.value);
    try {
      let temp = customerData.filter((customer) => {
        return customer.json.Full_Name.toLowerCase().includes(
          e.target.value.toLowerCase()
        );
      });
      setCustomerTempData(temp);
    } catch (err) {
      window.alert("Search is unavailable ,please make sure everything is filled in customer.arbatravel.com")
      console.log(err);
      setSearch("");
    }
  };

  function isWithin60Days(departureDate) {
    const today = new Date();
    const departDate = new Date(departureDate);

    // Calculate the difference in milliseconds between the two dates
    const differenceInTime = departDate.getTime() - today.getTime();

    // Calculate the difference in days
    const differenceInDays = differenceInTime / (1000 * 3600 * 24);

    // Check if the difference is less than 60 days
    if (differenceInDays <= 60) {
      return true;
    } else {
      return false;
    }
  }

  const handleDownload = (
    customerName,
    customerID,
    departureFlightDate,
    departureFlightCode,
    returnFlightCode,
    returnFlightDate,
    AccommodationAddress,
    AccommodationName,
    destination,
    pax,
    referenceNumber
  ) => {
    // get Today Date
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, "0");
    let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    let yyyy = today.getFullYear();

    today = dd + "/" + mm + "/" + yyyy;

    // Create a new window to open the PDF
    const pdfWindow = window.open("", "_blank");
    pdfWindow.document.open();
    pdfWindow.document.write(`
    <!DOCTYPE html>
     <html>
         <head>
             <title>Arba Travel Trip Confirmation</title>
             <style>
body {
margin: 0;
}
/* Copyright 2014 Mozilla Foundation
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*     http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

.textLayer {
position: absolute;
text-align: initial;
left: 0;
top: 0;
right: 0;
bottom: 0;
overflow: hidden;
opacity: 1;
line-height: 1;
-webkit-text-size-adjust: none;
-moz-text-size-adjust: none;
     text-size-adjust: none;
forced-color-adjust: none;
transform-origin: 0 0;
z-index: 2;
}

.textLayer span,
.textLayer br {
color: black;
position: absolute;
white-space: pre;
cursor: text;
transform-origin: 0% 0%;
}

/* Only necessary in Google Chrome, see issue 14205, and most unfortunately
* the problem doesn't show up in "text" reference tests. */
.textLayer span.markedContent {
top: 0;
height: 0;
}

.textLayer .highlight {
margin: -1px;
padding: 1px;
background-color: rgba(180, 0, 170, 1);
border-radius: 4px;
}

.textLayer .highlight.appended {
position: initial;
}

.textLayer .highlight.begin {
border-radius: 4px 0 0 4px;
}

.textLayer .highlight.end {
border-radius: 0 4px 4px 0;
}

.textLayer .highlight.middle {
border-radius: 0;
}

.textLayer .highlight.selected {
background-color: rgba(0, 100, 0, 1);
}

.textLayer ::-moz-selection {
background: #0000ff26;
}

.textLayer ::selection {
background: #0000ff26;
}

/* Avoids https://github.com/mozilla/pdf.js/issues/13840 in Chrome */
.textLayer br::-moz-selection {
background: transparent;
}
.textLayer br::selection {
background: transparent;
}

.textLayer .endOfContent {
display: block;
position: absolute;
left: 0;
top: 100%;
right: 0;
bottom: 0;
z-index: -1;
cursor: default;
-webkit-user-select: none;
-moz-user-select: none;
     user-select: none;
}

.textLayer .endOfContent.active {
top: 0;
}


:root {
--annotation-unfocused-field-background: url("data:image/svg+xml;charset=UTF-8,<svg width='1px' height='1px' xmlns='http://www.w3.org/2000/svg'><rect width='100%' height='100%' style='fill:rgba(0, 54, 255, 0.13);'/></svg>");
--input-focus-border-color: Highlight;
--input-focus-outline: 1px solid Canvas;
--input-unfocused-border-color: transparent;
--input-disabled-border-color: transparent;
--input-hover-border-color: black;
}

@media (forced-colors: active) {
:root {
--input-focus-border-color: CanvasText;
--input-unfocused-border-color: ActiveText;
--input-disabled-border-color: GrayText;
--input-hover-border-color: Highlight;
}
.annotationLayer .textWidgetAnnotation input:required,
.annotationLayer .textWidgetAnnotation textarea:required,
.annotationLayer .choiceWidgetAnnotation select:required,
.annotationLayer .buttonWidgetAnnotation.checkBox input:required,
.annotationLayer .buttonWidgetAnnotation.radioButton input:required {
outline: 1.5px solid selectedItem;
}
}

.annotationLayer {
position: absolute;
top: 0;
left: 0;
pointer-events: none;
transform-origin: 0 0;
z-index: 3;
}

.annotationLayer section {
position: absolute;
text-align: initial;
pointer-events: auto;
box-sizing: border-box;
transform-origin: 0 0;
}

.annotationLayer .linkAnnotation > a,
.annotationLayer .buttonWidgetAnnotation.pushButton > a {
position: absolute;
font-size: 1em;
top: 0;
left: 0;
width: 100%;
height: 100%;
}

.annotationLayer .buttonWidgetAnnotation.pushButton > canvas {
width: 100%;
height: 100%;
}

.annotationLayer .linkAnnotation > a:hover,
.annotationLayer .buttonWidgetAnnotation.pushButton > a:hover {
opacity: 0.2;
background: rgba(255, 255, 0, 1);
box-shadow: 0 2px 10px rgba(255, 255, 0, 1);
}

.annotationLayer .textAnnotation img {
position: absolute;
cursor: pointer;
width: 100%;
height: 100%;
}

.annotationLayer .textWidgetAnnotation input,
.annotationLayer .textWidgetAnnotation textarea,
.annotationLayer .choiceWidgetAnnotation select,
.annotationLayer .buttonWidgetAnnotation.checkBox input,
.annotationLayer .buttonWidgetAnnotation.radioButton input {
background-image: var(--annotation-unfocused-field-background);
border: 2px solid var(--input-unfocused-border-color);
box-sizing: border-box;
font: calc(9px * var(--scale-factor)) sans-serif;
height: 100%;
margin: 0;
vertical-align: top;
width: 100%;
}

.annotationLayer .textWidgetAnnotation input:required,
.annotationLayer .textWidgetAnnotation textarea:required,
.annotationLayer .choiceWidgetAnnotation select:required,
.annotationLayer .buttonWidgetAnnotation.checkBox input:required,
.annotationLayer .buttonWidgetAnnotation.radioButton input:required {
outline: 1.5px solid red;
}

.annotationLayer .choiceWidgetAnnotation select option {
padding: 0;
}

.annotationLayer .buttonWidgetAnnotation.radioButton input {
border-radius: 50%;
}

.annotationLayer .textWidgetAnnotation textarea {
resize: none;
}

.annotationLayer .textWidgetAnnotation input[disabled],
.annotationLayer .textWidgetAnnotation textarea[disabled],
.annotationLayer .choiceWidgetAnnotation select[disabled],
.annotationLayer .buttonWidgetAnnotation.checkBox input[disabled],
.annotationLayer .buttonWidgetAnnotation.radioButton input[disabled] {
background: none;
border: 2px solid var(--input-disabled-border-color);
cursor: not-allowed;
}

.annotationLayer .textWidgetAnnotation input:hover,
.annotationLayer .textWidgetAnnotation textarea:hover,
.annotationLayer .choiceWidgetAnnotation select:hover,
.annotationLayer .buttonWidgetAnnotation.checkBox input:hover,
.annotationLayer .buttonWidgetAnnotation.radioButton input:hover {
border: 2px solid var(--input-hover-border-color);
}
.annotationLayer .textWidgetAnnotation input:hover,
.annotationLayer .textWidgetAnnotation textarea:hover,
.annotationLayer .choiceWidgetAnnotation select:hover,
.annotationLayer .buttonWidgetAnnotation.checkBox input:hover {
border-radius: 2px;
}

.annotationLayer .textWidgetAnnotation input:focus,
.annotationLayer .textWidgetAnnotation textarea:focus,
.annotationLayer .choiceWidgetAnnotation select:focus {
background: none;
border: 2px solid var(--input-focus-border-color);
border-radius: 2px;
outline: var(--input-focus-outline);
}

.annotationLayer .buttonWidgetAnnotation.checkBox :focus,
.annotationLayer .buttonWidgetAnnotation.radioButton :focus {
background-image: none;
background-color: transparent;
}

.annotationLayer .buttonWidgetAnnotation.checkBox :focus {
border: 2px solid var(--input-focus-border-color);
border-radius: 2px;
outline: var(--input-focus-outline);
}

.annotationLayer .buttonWidgetAnnotation.radioButton :focus {
border: 2px solid var(--input-focus-border-color);
outline: var(--input-focus-outline);
}

.annotationLayer .buttonWidgetAnnotation.checkBox input:checked:before,
.annotationLayer .buttonWidgetAnnotation.checkBox input:checked:after,
.annotationLayer .buttonWidgetAnnotation.radioButton input:checked:before {
background-color: CanvasText;
content: "";
display: block;
position: absolute;
}

.annotationLayer .buttonWidgetAnnotation.checkBox input:checked:before,
.annotationLayer .buttonWidgetAnnotation.checkBox input:checked:after {
height: 80%;
left: 45%;
width: 1px;
}

.annotationLayer .buttonWidgetAnnotation.checkBox input:checked:before {
transform: rotate(45deg);
}

.annotationLayer .buttonWidgetAnnotation.checkBox input:checked:after {
transform: rotate(-45deg);
}

.annotationLayer .buttonWidgetAnnotation.radioButton input:checked:before {
border-radius: 50%;
height: 50%;
left: 30%;
top: 20%;
width: 50%;
}

.annotationLayer .textWidgetAnnotation input.comb {
font-family: monospace;
padding-left: 2px;
padding-right: 0;
}

.annotationLayer .textWidgetAnnotation input.comb:focus {
/*
* Letter spacing is placed on the right side of each character. Hence, the
* letter spacing of the last character may be placed outside the visible
* area, causing horizontal scrolling. We avoid this by extending the width
* when the element has focus and revert this when it loses focus.
*/
width: 103%;
}

.annotationLayer .buttonWidgetAnnotation.checkBox input,
.annotationLayer .buttonWidgetAnnotation.radioButton input {
-webkit-appearance: none;
-moz-appearance: none;
     appearance: none;
}

.annotationLayer .popupTriggerArea {
height: 100%;
width: 100%;
}

.annotationLayer .popupWrapper {
position: absolute;
font-size: calc(9px * var(--scale-factor));
width: 100%;
min-width: calc(180px * var(--scale-factor));
pointer-events: none;
}

.annotationLayer .popup {
position: absolute;
max-width: calc(180px * var(--scale-factor));
background-color: rgba(255, 255, 153, 1);
box-shadow: 0 calc(2px * var(--scale-factor)) calc(5px * var(--scale-factor))
rgba(136, 136, 136, 1);
border-radius: calc(2px * var(--scale-factor));
padding: calc(6px * var(--scale-factor));
margin-left: calc(5px * var(--scale-factor));
cursor: pointer;
font: message-box;
white-space: normal;
word-wrap: break-word;
pointer-events: auto;
}

.annotationLayer .popup > * {
font-size: calc(9px * var(--scale-factor));
}

.annotationLayer .popup h1 {
display: inline-block;
}

.annotationLayer .popupDate {
display: inline-block;
margin-left: calc(5px * var(--scale-factor));
}

.annotationLayer .popupContent {
border-top: 1px solid rgba(51, 51, 51, 1);
margin-top: calc(2px * var(--scale-factor));
padding-top: calc(2px * var(--scale-factor));
}

.annotationLayer .richText > * {
white-space: pre-wrap;
font-size: calc(9px * var(--scale-factor));
}

.annotationLayer .highlightAnnotation,
.annotationLayer .underlineAnnotation,
.annotationLayer .squigglyAnnotation,
.annotationLayer .strikeoutAnnotation,
.annotationLayer .freeTextAnnotation,
.annotationLayer .lineAnnotation svg line,
.annotationLayer .squareAnnotation svg rect,
.annotationLayer .circleAnnotation svg ellipse,
.annotationLayer .polylineAnnotation svg polyline,
.annotationLayer .polygonAnnotation svg polygon,
.annotationLayer .caretAnnotation,
.annotationLayer .inkAnnotation svg polyline,
.annotationLayer .stampAnnotation,
.annotationLayer .fileAttachmentAnnotation {
cursor: pointer;
}

.annotationLayer section svg {
position: absolute;
width: 100%;
height: 100%;
}

.annotationLayer .annotationTextContent {
position: absolute;
width: 100%;
height: 100%;
opacity: 0;
color: transparent;
-webkit-user-select: none;
-moz-user-select: none;
     user-select: none;
pointer-events: none;
}

.annotationLayer .annotationTextContent span {
width: 100%;
display: inline-block;
}


:root {
--xfa-unfocused-field-background: url("data:image/svg+xml;charset=UTF-8,<svg width='1px' height='1px' xmlns='http://www.w3.org/2000/svg'><rect width='100%' height='100%' style='fill:rgba(0, 54, 255, 0.13);'/></svg>");
--xfa-focus-outline: auto;
}

@media (forced-colors: active) {
:root {
--xfa-focus-outline: 2px solid CanvasText;
}
.xfaLayer *:required {
outline: 1.5px solid selectedItem;
}
}

.xfaLayer {
background-color: transparent;
}

.xfaLayer .highlight {
margin: -1px;
padding: 1px;
background-color: rgba(239, 203, 237, 1);
border-radius: 4px;
}

.xfaLayer .highlight.appended {
position: initial;
}

.xfaLayer .highlight.begin {
border-radius: 4px 0 0 4px;
}

.xfaLayer .highlight.end {
border-radius: 0 4px 4px 0;
}

.xfaLayer .highlight.middle {
border-radius: 0;
}

.xfaLayer .highlight.selected {
background-color: rgba(203, 223, 203, 1);
}

.xfaPage {
overflow: hidden;
position: relative;
}

.xfaContentarea {
position: absolute;
}

.xfaPrintOnly {
display: none;
}

.xfaLayer {
position: absolute;
text-align: initial;
top: 0;
left: 0;
transform-origin: 0 0;
line-height: 1.2;
}

.xfaLayer * {
color: inherit;
font: inherit;
font-style: inherit;
font-weight: inherit;
font-kerning: inherit;
letter-spacing: -0.01px;
text-align: inherit;
text-decoration: inherit;
box-sizing: border-box;
background-color: transparent;
padding: 0;
margin: 0;
pointer-events: auto;
line-height: inherit;
}

.xfaLayer *:required {
outline: 1.5px solid red;
}

.xfaLayer div {
pointer-events: none;
}

.xfaLayer svg {
pointer-events: none;
}

.xfaLayer svg * {
pointer-events: none;
}

.xfaLayer a {
color: blue;
}

.xfaRich li {
margin-left: 3em;
}

.xfaFont {
color: black;
font-weight: normal;
font-kerning: none;
font-size: 10px;
font-style: normal;
letter-spacing: 0;
text-decoration: none;
vertical-align: 0;
}

.xfaCaption {
overflow: hidden;
flex: 0 0 auto;
}

.xfaCaptionForCheckButton {
overflow: hidden;
flex: 1 1 auto;
}

.xfaLabel {
height: 100%;
width: 100%;
}

.xfaLeft {
display: flex;
flex-direction: row;
align-items: center;
}

.xfaRight {
display: flex;
flex-direction: row-reverse;
align-items: center;
}

.xfaLeft > .xfaCaption,
.xfaLeft > .xfaCaptionForCheckButton,
.xfaRight > .xfaCaption,
.xfaRight > .xfaCaptionForCheckButton {
max-height: 100%;
}

.xfaTop {
display: flex;
flex-direction: column;
align-items: flex-start;
}

.xfaBottom {
display: flex;
flex-direction: column-reverse;
align-items: flex-start;
}

.xfaTop > .xfaCaption,
.xfaTop > .xfaCaptionForCheckButton,
.xfaBottom > .xfaCaption,
.xfaBottom > .xfaCaptionForCheckButton {
width: 100%;
}

.xfaBorder {
background-color: transparent;
position: absolute;
pointer-events: none;
}

.xfaWrapped {
width: 100%;
height: 100%;
}

.xfaTextfield:focus,
.xfaSelect:focus {
background-image: none;
background-color: transparent;
outline: var(--xfa-focus-outline);
outline-offset: -1px;
}

.xfaCheckbox:focus,
.xfaRadio:focus {
outline: var(--xfa-focus-outline);
}

.xfaTextfield,
.xfaSelect {
height: 100%;
width: 100%;
flex: 1 1 auto;
border: none;
resize: none;
background-image: var(--xfa-unfocused-field-background);
}

.xfaSelect {
padding-left: 2px;
padding-right: 2px;
padding-inline: 2px;
}

.xfaTop > .xfaTextfield,
.xfaTop > .xfaSelect,
.xfaBottom > .xfaTextfield,
.xfaBottom > .xfaSelect {
flex: 0 1 auto;
}

.xfaButton {
cursor: pointer;
width: 100%;
height: 100%;
border: none;
text-align: center;
}

.xfaLink {
width: 100%;
height: 100%;
position: absolute;
top: 0;
left: 0;
}

.xfaCheckbox,
.xfaRadio {
width: 100%;
height: 100%;
flex: 0 0 auto;
border: none;
}

.xfaRich {
white-space: pre-wrap;
width: 100%;
height: 100%;
}

.xfaImage {
-o-object-position: left top;
object-position: left top;
-o-object-fit: contain;
object-fit: contain;
width: 100%;
height: 100%;
}

.xfaLrTb,
.xfaRlTb,
.xfaTb {
display: flex;
flex-direction: column;
align-items: stretch;
}

.xfaLr {
display: flex;
flex-direction: row;
align-items: stretch;
}

.xfaRl {
display: flex;
flex-direction: row-reverse;
align-items: stretch;
}

.xfaTb > div {
justify-content: left;
}

.xfaPosition {
position: relative;
}

.xfaArea {
position: relative;
}

.xfaValignMiddle {
display: flex;
align-items: center;
}

.xfaTable {
display: flex;
flex-direction: column;
align-items: stretch;
}

.xfaTable .xfaRow {
display: flex;
flex-direction: row;
align-items: stretch;
}

.xfaTable .xfaRlRow {
display: flex;
flex-direction: row-reverse;
align-items: stretch;
flex: 1;
}

.xfaTable .xfaRlRow > div {
flex: 1;
}

.xfaNonInteractive input,
.xfaNonInteractive textarea,
.xfaDisabled input,
.xfaDisabled textarea,
.xfaReadOnly input,
.xfaReadOnly textarea {
background: initial;
}

@media print {
.xfaTextfield,
.xfaSelect {
background: transparent;
}

.xfaSelect {
-webkit-appearance: none;
  -moz-appearance: none;
       appearance: none;
text-indent: 1px;
text-overflow: "";
}
}


:root {
--focus-outline: solid 2px blue;
--hover-outline: dashed 2px blue;
--freetext-line-height: 1.35;
--freetext-padding: 2px;
--editorFreeText-editing-cursor: text;
--editorInk-editing-cursor: pointer;
}

@media (-webkit-min-device-pixel-ratio: 1.1), (min-resolution: 1.1dppx) {
:root {
}
}

@media (forced-colors: active) {
:root {
--focus-outline: solid 3px ButtonText;
--hover-outline: dashed 3px ButtonText;
}
}

[data-editor-rotation="90"] {
transform: rotate(90deg);
}
[data-editor-rotation="180"] {
transform: rotate(180deg);
}
[data-editor-rotation="270"] {
transform: rotate(270deg);
}

.annotationEditorLayer {
background: transparent;
position: absolute;
top: 0;
left: 0;
font-size: calc(100px * var(--scale-factor));
transform-origin: 0 0;
cursor: auto;
z-index: 4;
}

.annotationEditorLayer.freeTextEditing {
cursor: var(--editorFreeText-editing-cursor);
}

.annotationEditorLayer.inkEditing {
cursor: var(--editorInk-editing-cursor);
}

.annotationEditorLayer .selectedEditor {
outline: var(--focus-outline);
resize: none;
}

.annotationEditorLayer .freeTextEditor {
position: absolute;
background: transparent;
border-radius: 3px;
padding: calc(var(--freetext-padding) * var(--scale-factor));
resize: none;
width: auto;
height: auto;
z-index: 1;
transform-origin: 0 0;
touch-action: none;
cursor: auto;
}

.annotationEditorLayer .freeTextEditor .internal {
background: transparent;
border: none;
top: 0;
left: 0;
overflow: visible;
white-space: nowrap;
resize: none;
font: 10px sans-serif;
line-height: var(--freetext-line-height);
}

.annotationEditorLayer .freeTextEditor .overlay {
position: absolute;
display: none;
background: transparent;
top: 0;
left: 0;
width: 100%;
height: 100%;
}

.annotationEditorLayer .freeTextEditor .overlay.enabled {
display: block;
}

.annotationEditorLayer .freeTextEditor .internal:empty::before {
content: attr(default-content);
color: gray;
}

.annotationEditorLayer .freeTextEditor .internal:focus {
outline: none;
}

.annotationEditorLayer .inkEditor.disabled {
resize: none;
}

.annotationEditorLayer .inkEditor.disabled.selectedEditor {
resize: horizontal;
}

.annotationEditorLayer .freeTextEditor:hover:not(.selectedEditor),
.annotationEditorLayer .inkEditor:hover:not(.selectedEditor) {
outline: var(--hover-outline);
}

.annotationEditorLayer .inkEditor {
position: absolute;
background: transparent;
border-radius: 3px;
overflow: auto;
width: 100%;
height: 100%;
z-index: 1;
transform-origin: 0 0;
cursor: auto;
}

.annotationEditorLayer .inkEditor.editing {
resize: none;
cursor: inherit;
}

.annotationEditorLayer .inkEditor .inkEditorCanvas {
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100%;
touch-action: none;
}

:root {
--viewer-container-height: 0;
--pdfViewer-padding-bottom: 0;
--page-margin: 1px auto -8px;
--page-border: 9px solid transparent;
--spreadHorizontalWrapped-margin-LR: -3.5px;
}

@media screen and (forced-colors: active) {
:root {
--pdfViewer-padding-bottom: 9px;
--page-margin: 8px auto -1px;
--page-border: 1px solid CanvasText;
--page-border-image: none;
--spreadHorizontalWrapped-margin-LR: 3.5px;
}
}

[data-main-rotation="90"] {
transform: rotate(90deg) translateY(-100%);
}
[data-main-rotation="180"] {
transform: rotate(180deg) translate(-100%, -100%);
}
[data-main-rotation="270"] {
transform: rotate(270deg) translateX(-100%);
}

.pdfViewer {
background-color: #d7d7d7;
padding-bottom: var(--pdfViewer-padding-bottom);
}

.pdfViewer .canvasWrapper {
overflow: hidden;
width: 100%;
height: 100%;
z-index: 1;
}

.pdfViewer .page {
direction: ltr;
width: 816px;
height: 1056px;
margin: var(--page-margin);
position: relative;
overflow: visible;
border: var(--page-border);
-o-border-image: var(--page-border-image);
border-image: var(--page-border-image);
background-clip: content-box;
background-color: rgba(255, 255, 255, 1);
}

.pdfViewer .dummyPage {
position: relative;
width: 0;
height: var(--viewer-container-height);
}

.pdfViewer.removePageBorders .page {
margin: 0 auto 10px;
border: none;
}

.pdfViewer.singlePageView {
display: inline-block;
}

.pdfViewer.singlePageView .page {
margin: 0;
border: none;
}

.pdfViewer.scrollHorizontal,
.pdfViewer.scrollWrapped,
.spread {
margin-left: 3.5px;
margin-right: 3.5px;
text-align: center;
}

.pdfViewer.scrollHorizontal,
.spread {
white-space: nowrap;
}

.pdfViewer.removePageBorders,
.pdfViewer.scrollHorizontal .spread,
.pdfViewer.scrollWrapped .spread {
margin-left: 0;
margin-right: 0;
}

.spread .page,
.spread .dummyPage,
.pdfViewer.scrollHorizontal .page,
.pdfViewer.scrollWrapped .page,
.pdfViewer.scrollHorizontal .spread,
.pdfViewer.scrollWrapped .spread {
display: inline-block;
vertical-align: middle;
}

.spread .page,
.pdfViewer.scrollHorizontal .page,
.pdfViewer.scrollWrapped .page {
margin-left: var(--spreadHorizontalWrapped-margin-LR);
margin-right: var(--spreadHorizontalWrapped-margin-LR);
}

.pdfViewer.removePageBorders .spread .page,
.pdfViewer.removePageBorders.scrollHorizontal .page,
.pdfViewer.removePageBorders.scrollWrapped .page {
margin-left: 5px;
margin-right: 5px;
}

.pdfViewer .page canvas {
margin: 0;
display: block;
}

.pdfViewer .page canvas[hidden] {
display: none;
}

.pdfViewer .page canvas[zooming] {
width: 100%;
height: 100%;
}

.pdfViewer .page .loadingIcon {
position: absolute;
display: block;
left: 0;
top: 0;
right: 0;
bottom: 0;
z-index: 5;
}
.pdfViewer .page .loadingIcon.notVisible {
background: none;
}

.pdfViewer.enablePermissions .textLayer span {
-webkit-user-select: none !important;
-moz-user-select: none !important;
     user-select: none !important;
cursor: not-allowed;
}

.pdfPresentationMode .pdfViewer {
padding-bottom: 0;
}

.pdfPresentationMode .spread {
margin: 0;
}

.pdfPresentationMode .pdfViewer .page {
margin: 0 auto;
border: 2px solid transparent;
}
</style>
         </head>

         <body>
             <div class="pdfViewer" style="--scale-factor: 1.25;"><div class="page" style="height: 990px; width: 765px;"><div class="canvasLayer"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAv0AAAPeCAYAAACfiaU4AAAAAXNSR0IArs4c6QAAIABJREFUeF7s3QeYZQV5N/D3Tt2+M4uAGguxgSFRrLELdhN7Q+mINBtixY4FCypNFKQLCCpBNCb2CCbmS9HEHpOYRDSxw+5sn53dmfs95y4guztz7529M+fsnvd3n+d7/D73nPOe9/ee6/e/Z05pNJvNZvgQIECAAAECBAgQIFBbgYbQX9vZaowAAQIECBAgQIBAS0DodyAQIECAAAECBAgQqLmA0F/zAWuPAAECBAgQIECAgNDvGCBAgAABAgQIECBQcwGhv+YD1h4BAgQIECBAgAABod8xQIAAAQIECBAgQKDmAkJ/zQesPQIECBAgQIAAAQJCv2OAAAECBAgQIECAQM0FhP6aD1h7BAgQIECAAAECBIR+xwABAgQIECBAgACBmgsI/TUfsPYIECBAgAABAgQICP2OAQIECBAgQIAAAQI1FxD6az5g7REgQIAAAQIECBAQ+h0DBAgQIECAAAECBGouIPTXfMDaI0CAAAECBAgQICD0OwYIECBAgAABAgQI1FxA6K/5gLVHgAABAgQIECBAQOh3DBAgQIAAAQIECBCouYDQX/MBa48AAQIECBAgQICA0O8YIECAAAECBAgQIFBzAaG/5gPWHgECBAgQIECAAAGh3zFAgAABAgQIECBAoOYCQn/NB6w9AgQIECBAgAABAkK/Y4AAAQIECBAgQIBAzQWE/poPWHsECBAgQIAAAQIEhH7HAAECBAgQIECAAIGaCwj9NR+w9ggQIECAAAECBAgI/Y4BAgQIECBAgAABAjUXEPprPmDtESBAgAABAgQIEBD6HQMECBAgQIAAAQIEai4g9Nd8wNojQIAAAQIECBAgIPQ7BggQIECAAAECBAjUXEDor/mAtUeAAAECBAgQIEBA6HcMECBAgAABAgQIEKi5gNBf8wFrjwABAgQIECBAgIDQ7xggQIAAAQIECBAgUHMBob/mA9YeAQIECBAgQIAAAaHfMUCAAAECBAgQIECg5gJCf80HrD0CBAgQIECAAAECQr9jgAABAgQIECBAgEDNBYT+mg9YewQIECBAgAABAgSEfscAAQIECBAgQIAAgZoLCP01H7D2CBAgQIAAAQIECAj9jgECBAgQIECAAAECNRcQ+ms+YO0RIECAAAECBAgQEPodAwQIECBAgAABAgRqLiD013zA2iNAgAABAgQIECAg9DsGCBAgQIAAAQIECNRcQOiv+YC1R4AAAQIECBAgQEDodwwQIECAAAECBAgQqLmA0F/zAWuPAAECBAgQIECAgNDvGNhGYPLGn8XGa6+Nxa94eTSGhnY9nWYzpm66Oca//JVoTE7Ozf41GtFYviwG9r1P9N/lLhGDg9EYHIzo65ub7e/EVprj47Hpq1+L5spVO7H2NKv0NaIxOhoD97hH9P3BnVuzbfXY3x/RaMxNjZK20tywIdZ/5LxYdNgh0XenO5VUVRkCBAgQILB7Cwj9u/f85nTvJ3/5y1h1xNHRXLkyBvbbN0YuvTgaw8NzWqPXjW3+zndj9SteGc0NG3vd1LTrNxYujL6994r+u989hh75yBj+s6dE36JF81Jrpo1OjY3F6mOPjy3//T/zU3doKPpGlkf/Xe8agwfcPxY84+mt//vu8CkC/6pDj4jJn/2sNaeRj18a/XvttTvsun0kQIAAAQKVCgj9lfLvWsU3fOLqWH/GmRHNZuss9/KzPhRDj3rULrWTGz9+Raw7+5zS9qnvDneIpae8PgYf/rAofhCU8Sl+2Iwdc2wZpVo1GgsWxOKXvzQWPOuZ0Sj5B85sm5z42t/E6lPeFDE11foLxdI3vzEWPOfZs92M5QkQIECAQDoBoT/dyKdveKo4g/qs58bUTTfdtsDQYx4dy886Y5cS2nDZ5bH+nA+Xuk+NgYEYePCDYtmpb4u+Es4qb/7X78TYS44rtcciQA894uGx7PT3lfbjZmcaXH3cCTHx7X+5bdW+O98p9rju2tYlWT4ECBAgQIDAzAJCv6OjdWZ//Uc+GhsuuWxbjUYjRi66IAYfcMAuo1RF6L+1+f7irP8HT4/B+/3JvHpUEvpv6ei24L8LnvGf+Nu/i9WvevUO9otf9tJY9OKjdrt7E+b1ILJxAgQIECCwnYDQ75CIqd/+NlYddUxM/frXO2gM3Oc+MXr5pRG7yE29VYb+Aqdvzz1j9IrL5vWMf5Whv+hxyUmvjIVHHr5LfTOa6zfEqiOOismf/nSH/Spuvi7uP+nbY8Uutc92hgABAgQI7EoCQv+uNI2K9mXjJz8V6z7woa3X8m//q3B4OJadfUYMPfShFe3dtmWrDv2t4L/33jF62cWt/5yPT9Whv7iJecW1n6706UXbu27622/G2te/IZoTEzuSF9f2v+0tseCZz5iPcdgmAQIECBCohYDQX4sx7nwTxdNQbn78k6K5adOMGxl6+J/G8o+cu/NF5nDNXSH0F+0sPPgFseQNr5vDzn6/qapDf7Enyz5wegw//qB56W9nNlo8VWrLD38446qNpUtjj69+add8zOzONGwdAgQIECAwxwJC/xyD7laba13Lf15suOTS9rvdaMSys86I4UdX/ySfbkJ/8SjHxUcfFY099uhqHMVT6ifXrYupn/40xr9+Q0z93/91XK94ys3olZdH/z5377jsbBfoJvQXz9hf+MKDY+CP9+/ujPz4eEz8y7/Gpi9+qe0PvFv3dWD//bde1rULPMO/eCfD2je+uSOja/s7ElmAAAECBBILCP2Jh99cuzZWHnZkTP3v/3ZUKJ7nvvy8j0ZjuNoXdnUT+pec8vpY+ILnd+xppgXWvvNdMf65z097udPt12nd9HrOWdGY45d4dRP6h5/y5Fj2nnfPusdNX78+1r7pLdNfJnO7rRUv71rxlS9G37Jls64xpyuMj8eq4p0FP/q3jpvtv8cfxujll+3yjx3t2IgFCBAgQIDAPAgI/fOAurtscuOVV8W6M8/qGG5b/QwPx+hFH4viDHCVn25C/7IzPhjDBz5253dzYiLWX3RxbLjokrbbaCxeHKNXX7n1Lb5z+Okm9C868ohYfNIrZl+12YxNX/hirHnbqe3nPjAQKz79yXn5S8Zsdnrzt74dq19xUscfKa1t9vXFkre8KRY+65mzKWFZAgQIECCQQkDoTzHmHZucuvnmWPm0Z3Z1qcetaw886IExct5HonhufVWfUkJ/0dzkZOvtxFt+/OOZWy1eYPbB02Oolx8Y02x9XkP/LfVWHXJ4bPn3f5+xt0Z/fyy/+MJ5fzxpu+OouGl37Khj2u7n9usXP8T2+Ou/jEbVf6Go6guiLgECBAgQmEFA6E96aKy/8OLYcN75s+u+0YjlZ3wwhh77mNmtN4dLlxb6I2LDRRfH+o+2N1p83Eti0QnHz2GHEWWE/nXvfk9s/Mx1bX/QjJz/kRh88IPntLfZbKy4/2DNm986m1Vayy45+VWx8PBDZ72eFQgQIECAQJ0FhP46T3em3jZvjpUveGFM/uzns+5+6JGPiOVnn9ndzaOz3nrnFcoM/Zt//OMYO/SItjtVnOUvfgjN5aeU0H/m2bHxiit33dA/NRWrT3xZTHzr27OmHbjXvWL0k5+o7Bid9Q5bgQABAgQIlCAg9JeAvKuV2HDxpa038O7Mp7i0Z/SaT0X/3e+2M6v3vE6Zob85Ph43P+agaG7ZMuN+D+x7nxi9+hM993X7DZQS+k97T2y8ts2Z/v7+GP3EFTFwn3vPaW/dbmzLj34Uq458ccTUVLer/H65RiNaN3M//3mzX9caBAgQIECgpgJCf00HO1NbxVt3Vz73BdHcuHGnOx+8736x/JKLK3mST5mhvwBa+aznxOTPZ366Uf8f3DlWfP5zO2053YplhP6xI46KzT/80Yz73bo2/kt/HcV/lv0pjs3inoPJn/1sp0sXz+0vXjDWd4c77PQ2rEiAAAECBOokIPTXaZpd9LLxE1fFug+d2cWS7RdZXryl99GP7nk7s91A2aF/1cGHxJaf/GTG3ezfe69Y8cW/nm0bbZef79C/+Xvfi7GjX9J2Hxa96IWx+HWvmdO+ut3Ypq98Ldac8sZuF59+ueJs/xvfEAuf99zetmNtAgQIECBQEwGhvyaD7KaN4nKVVc9/YUz+4hfdLN52meKRmMWjMcv+lBr6m824+c+eFlO/+e3Mof/ud4sV1107pwzdhP4FL3h+LD3l9bOuu+Xfftx6BObUqlUzrtu3xx4xeu010bds6ay3PxcrtK7l/6d/7nlT/fvsEys+fXVEhU+b6rkJGyBAgAABAnMkIPTPEeQuv5lmMzZ87MJYf8GF7Xd1aCgG7nGPzo9JbDRi5BNXxOB++5baepmhv3is6c1PfErb/gbv9ycxcln75/nPFqib0N8YHY3R8z8Sjb32jiheKdzu04yITeMx8Z3vxrr3vj+aa9a0XXzhUUfGkle+fLa7PSfLb/72v8TYcSd03NbAffeLyZ/8V9v7LYqNLDn5pFh4+GEdt2cBAgQIECBQdwGhv+4TvqW/qd/8pvXc+anf/a5tx4uPPy4WHXVEjL342CieXtPuM3Cf+7QCb2PBcGmKZYb+jdd9Nta967S2vS14+tNi6TvePqf9dxP6i4KNhQujb++9I/rap/5GM2Jq9eqYGhvreGNs/x/dN0Y/cm40lpf/Jt7m+g2x6vAjY/LGG9v/0Hrwg2L5uefE+nPOjY1XXd122f473SlGPn6Ja/vn9Ai1MQIECBDYHQWE/t1xajuxz+PX/EWsfd/pbd/C2rfXXjH66aujb9my2FxcBvLil7R9E2pjaCiWnfmhGHr4w3Zij3ZulbJCf3Pz5lh93Amx+Xvfb7ujS173mlj4ohfuXDMzrNVt6J/Loo2+vhh86ENi2fvfG8VNsFV8Nn3jb2PN694Q0eZpScWboff41NXRd7e7xtTKlbHqeQdv/TEz06evL5a+7a2x4BlPq6IlNQkQIECAwC4jIPTvMqOYvx0pnoZy89OeEc1VbcJRRCx4zrNjyZtOiSIAFo9K7OY56cWLupaf+aH52/nttlxW6F93xllbzyK3e2Tk0FCMfPTcGHzgA+a0/7JDf2PRoljymlfF8JOeHI3Fi+a0l9lsbOy4E2Pzt9s/l3/oUY+M5Wed0XoGf3NyKta+5a2x6ctfaVumf++9Y/Qvr4vG4OBsdseyBAgQIECgVgJCf63GOU0zzWasP/9jseHCi9t2Wpy1H736yuj/wz+8bbnxz30+1r7jne2Fimv7P3ZeDD74QaVIdhX63/3OGP6zp+7U/kytXRsbL78yNlzc+Tr9vj33jBXXfDIay+b2UpgyQ3/xSM7FLz0hhh72p9F/97tX9kKrTTd8I9a8+rUdZ7bsg6fH8OMOum254rGjq48+JpqTk23XXXLSK2LhEYdHNDrdANFxFyxAgAABAgR2SwGhf7ccW/c73Rwba73kaPJ/Z37WfLG1BQc/P5a+YbunwWyZ3Pr0mptualtwYP/9Y+TiC6L44TDfn25C/8D+fxQjF184q/2Z2rAhNn3+r2LD+RfEVHGja7O4+7X9Z/HJr4pFhx/aabFZ/3uZob+1c41G6yz40OMOimWnvi2ihDneHqV4qtTY0cfElv/4z/bH2b3vtfVFaMVfom73Wf2GN8bEV7/Wdt3ix+zIJRdFXwX3Ksz6ALACAQIECBCYBwGhfx5Qd6VNFtfyr3v/B6LZ5jKV4kz16CUXRf89fn+W/9YeNn31a7HmjW9ue5lLcUPp8uIyl/vfb95b7yb0t3LswoVRPOGmq8/UVOv68JiY6GrxYqGB/faN0csvm5fHQZYe+m/X9cC97hlL3nhKDD7ggK4tel2weDzn6pNObutf/KBc/uGzYvAhD9mh3OYf/VusPv7EaG7YMPOu9PXFsne8PYb//M963V3rEyBAgACB3VJA6N8tx9bdTjfXro2bnvTUiE2b2q5Q3Ii7/MNnT3tpx9TqNTH24pfE5E9/2nYbgw97WIycO/02utvb7pbqNvR3t7WdXKqvL5Z/4P0xdNCBO7mB9qtVGfqLPWtdtvSpq6Mxsnxe+rv9Rosfo6uPfkls/sEP2tYauO99Y+TCj0Vj0cIdl5uYiLFjj4/NP/hh220UNyi33jK8cJptzHunChAgQIAAgWoFhP5q/ee1+oYLLmpdz9/u0+jvj5ErL4+Bfe8z/WLFPQEXXtS67KX9hhqx/Owzo7jRcj4/VYf+4ibnhSccF4uPPiqiv39eWu029BcBeODe94no3/Zyl2l3anKy9deMyV/8suNjO4v1++961xi54LytjwSdx8/4V74Sa095c8cKS9/yptaN5jN9Jv7+/7VeOtbps+RVJ8XCIzy3v5OTfydAgACB+gkI/fWb6daOJiZi5QsP7fjM8wVPeXIsfc+72yoUl02sfNoz2z8aMSKGHvawWH7OmfNyycutO1hp6G80ovVc/re9ZV5veO0m9G99/vyl0XeHPWZ1BE/94hex7uJLYvPXvh5T69a1Xbe48XXJq145q+3PauGJiVj90pfHxL9+p+1qfXe9S+utx62nSrX5tM72/8u/tl2meLfE6BWXRXiSz6xGZWECBAgQ2P0FhP7df4bTdlA8bnLdh85sf0Nq8cjJGa6T3n6jG6/8RBSPsWz3aQwPx8gVH4/iuvD5+lQV+osbXRedeHwsfMHzo3jE5Xx+ugn9iw55USx+7at3ejcm/u6bW6+jb/Mp+hz9zDXRv9deO12n3Yqbv//9GDv2hIjNm2derLgW/13viOGntn8zcrGBTX/z9Vhzypsi2j3Jp9je298Ww0//83npyUYJECBAgMCuKiD076qT6WG/irfu3vz0Z3W8MXXgnveMkSs/HkVY7/Qpnv4zduSLO57tL24AXX7+R+ftmeilh/6+vhi45z1i4YuPjgVPfMK8nuG/dQZdhf4jj4jFJ72i09ja/vv4X1y79YVtbW7yXvD858XSN76hpzrTrdzctClWH/Xi2NzhiT19e+8Vo1d8vKs36hb3n6x64SFRvH2604+ZFZ//bPR1e6P3nHdvgwQIECBAoHwBob9883mvuPHyK2LdWed0rFNcI11cK93Np3jB16oXvCgmf/GLjosvO/vMGH70ozoutzMLlB36Bx/yoFj+gdPn/Fn87XovK/Q316+PVUccFZM/vXHG3em7y11ixSevmv4G2p0Z4C3rbPra38Sa15/ScQuD++3buudk+8d0zrTi2PEnxuZvtX/BV7HuklNe3/qrjQ8BAgQIEMgiIPTXbNLNiYlYdfAhMfmzn3XubHg4Fvz5n3X1Ftap3/w2Nn39+ogtWzpud/igx8ayD32w43I7s0BXob+vLwb/eP9orFixY4mNG6N4oVMReLv5LHvfe2L4SU/sZtE5W6a00L9lS6w56eSY+Id/nDn0r1gRo1d+PPrueMc566/Y0OqXvTIm/uEfOm9zaKj1F5bGis6PX22uXRfjf/2F9pcL3VKx/973jtGrrojiRnYfAgQIECCQQUDor9mUN1xyWaw/9yOVdlXccDn6+c9GcbPpXH+6Cf0Lnv2sWPrWmZ8I07q05OWv7HjTZ7Hv/cXz+C+9uKtLoOaq17JCf3FZz+pXvzYm/vbvZg79y5fFyKUXR/8++8xVezH1k/+Kmw9+0Zxtb2c35Gz/zspZjwABAgR2RwGhf3ec2gz7XJyNX3XIYTG1alXlXQ3cd79WWJ7rt7t2E/pbz9B//OPaGkzdvDJWv/wVHd8CWzyWc/FLT4hFxSM6S/qUFfqLvwqtftkr2v74KV7cNnLZJTGwz93npPvWZWKHHdnxvQ9zUqzDRvr33DNGrroi+vaY3ROQytg3NQgQIECAwFwLCP1zLVrh9jYWb98tbsxsNivci62li7P9y889O4qXds3lp5vQv+yMD8bwgY/tWHbq17+JlS86JJqr13Rctrg5efAhD45Go9Fx2V4XKCv0Fz98Vr7g4GiuGptxl/v2WLH1Rto5urxn4oZvxOrXvr6rdwX06thx/daTfN4aw09/WsdFLUCAAAECBHZ3AaF/d5/gLfvfHB+PVc99QUz+6le7TEdDjzsoln/w9Dndn7kM/cXlLRs/cVWsO/PsjvvYf7e7xsglF0XfdPcJdFx7dguUFfrXnf7B2PjJT7Xduf69946Rq6+MvpGR2TUxw9JdX8s/J9U6b6T/7neLFdd8al7fLdF5LyxBgAABAgTmX0Don3/j+a/QbMaGCy/u+Pbd+d+R7So0GjF6+WUxsP8fzVnpOQ39t+zV6pNeHRPf/GbHv5AMH3RgLD3tXdFYsGDO+pluQ92F/sNj8Uk7/+KsTV/9Wqx5wxs79jFwyw2vc/H24c3//K0YO+GlHWuWvcDiV78qFh12aNll1SNAgAABAqUKCP2lcs9Psambb45VxTP0f/nL+SnQw1YH998/Ri6+YM6u7Z+P0D/5y1/G6mOOi8kOz3cvGBYff1wsOu4lEfN4mU83oX/wQQ+MkQs/NvvJTE3F+Oc+H+vOOjuaa9d2XH/RoYfE4te0f4lXx41EROta/qOOicmf/KSbxUtdpjjb3/orjuf2l+quGAECBAiUKyD0l+s9L9XGP3NdrH3P+7q6Trpv8eI5CazNyclWkOv0Kc6KLz/3nBh84AM6LdrVv89H6C8Kb/ryV2LN29/R8YVmjaVLY/lHz43BOfzrxfaNdxP6i3WGHv6wGHzoQ7p+hn1zw8bY/I//GJu//4OOf9Uott8YGIjRT14V/ff4w65m026h4vGca1792mhumui4rcbChXPyKM3m1FQ0N2zoWK94B8Cyd50aw099audlLUGAAAECBHZTAaF/Nx3cbbs9Ph43Pemp0Vy3rm0nfXvuGUvf/tYYuN+fzMnNqM3NW2LT174W6844K2J8vG3tocc+Jpaf+aE5kZ6v0F/c/Lz+o+fHhosv6byfQ0Oxx19+Nvr22rPzsjuxRLehfyc2PatVhh75iFj+4c73O3Sz0bFjj+/4iNTG4sWx5A2vi+HHPCaiv6+bzbZdptlstl7Ute5dp3V8k3Rxw/KKL/zVvL1JuudmbIAAAQIECPQoIPT3CFjp6kVQveji2HBe+8s8ikcSjlx4/pw+a73Vd7MZE1+/PlYX14ZPTc1IUTzJZ9lHz42h4qx0j595C/1FO6tWxdiJL48t//mfHfeyeGFX8eKu+fjsCqG/NbNzzoqhRzy85xY33fCN1ln+dp9Gf18sO3tu6m1fZ8u//0fr0aSdHmW7+OSTYtHhh/Xcrw0QIECAAIFdUUDo3xWn0uU+FW+VHTvi6Njy05/OvEajEUte/apYeOghXW519outOeVNsekrX2274tBDHhzLzj2n5zOp8xn6iwaKYLjyWc+J4u2unT6tG0AL1zm+vr/y0N9oxPATHh/L3v/eTgSd/31iIsaOO2HrJUVtPsNPfUosO+1dnbe3k0tsuPyKWH/2h9te1tR/73ttfRHbokU7WcVqBAgQIEBg1xUQ+nfd2XTcs43XXhfr3tv+Wv6+FaMxcvll0X/nO3fc3s4uUJxJLYJdu0uMiiA1ctEFMbDfvjtbprXefIf+osb4Zz8Xa9/57s77uWBBjBTX9x9w/87LzmKJqkP/0EEHxrL3nhaNoaFZ7PX0i27+7vdi9Ykvi+ItyDN9GkuWtG5KHtj3Pj3Xm2kDxc3aY0ccFVMr27y4rq8vlr77nbHgKU+et/2wYQIECBAgUJWA0F+VfI91m6tXx81PfVoUz+dv91l46ItiyWte3WO19qs3t2yJ1SedHJv/4R/bLljceNq6Rrxv56/XLiP0F5ctFS+QKl4k1elFZ4P77RfLL/xYNBbP3dnhykL/0FAMP+ZRsfQdp0ZxM22vn9ZxccyxsfkHP2x/XDzsT2P5OWfN+7Pyi/tPNl75ifZtLV0Sd/jrv4rGksW9tm99AgQIECCwSwkI/bvUOLrfmQ3nXxDrL7iw7Qr9d7xjjF7zyShukJzvz+R//0+setGhUQS9GT+NRiv093Kd+Marro51HzyjbTsjxdOCerwWvXjqy+rjXxqbf/SjjnQLnv3MWPqWN8/ZZT7FpTBjR724Y905W6DRiIH77heLTzwhhh72pzEXz+Qv9m3T16+PNcXbd9t9BgZixVVXRP+97jVn7cy0oWKmK593cEz9+tdtay1+5ctj0VFHzvv+KECAAAECBMoUEPrL1J7DWuve/4HWZSjFE0q2/xQ3Yfbd6U6x5LWvbj3WsazP+Gc+GxsuvTSmbrp5xv1a8pqTY8Fzn7PTuzT5X/8Vq1/3hpj61a9j+86LvotLRIpHhM7FD53Jn/081n3ojNjyo3+LqfXrZ9zn4cc8OpYWl8P09+90X7dfsbgUZs3Jr43N3/9++x9Rs6zWKO496O+PxsIF0Vi2PPpGR2LgPveO4YMO2vpI1Tna/1t3a+O1n4n1HzozikdnTvfp3/MOsejYl8SCZzx9lp3s/OITf/fNWHfWOTH1q1/NuF8Ln/XMWHJKhx8rO78L1iRAgAABApUICP2VsPdetHhGfnPV2PQbahRvkVocfUuXztnZ5672eGoqplavbj2/vxHFTmz3aUT07XGHiKHBrjY300KtGus37FihEdEYGZmTS1Nurd3cvDmaY2MRm2f+C0Zj+bI5+ZGxTb8Tm2Nq5c0RUzv+qOsFr9nXaD1/vzE8HDE8PCfX7c+0P82JiSheHNeYpoXivyp+fPQtX97T5V6ztmg2Y2rt2ihugp9uv4rtNUaWu5l31rBWIECAAIFdXUDo39UnZP8IECBAgAABAgQI9Cgg9PcIaHUCBAgQIECAAAECu7qA0L+rT8j+ESBAgAABAgQIEOhRQOjvEdDqBAgQIECAAAECBHZ1AaF/V5+Q/SNAgAABAgQIECDQo4DQ3yOg1QkQIECAAAECBAjs6gJC/64+IftHgAABAgQIECBAoEcBob9HQKsTIECAAAECBAgQ2NUFhP5dfUK78P5t+clPYvK//6f9Hg4PxdAjHrH1ZVC3+2z5r/+O4u26O3wajejfb98YuPtQW/LDAAAgAElEQVTdZ9355M//L/ruuFfbF05t/sd/iqmxsei/xz1ab6Od7jP1u9/FxLf/JYo32A499jE7vOyreOHU5m99u/3+DQy03nQb/X3bLtdsxsQ3/jaa4+Mx8OAHRf8d7jDrPrtZYcv3vh8br/tsTP70pxELFsTggx4YC5//vOgbHe1m9dYyk7/8ZRRv1S22FZOTMXDve8eC5z13Rrdt5vvTG6N4425jyZKu623+8Y9j8L737Xp5CxIgQIAAAQLdCwj93VtZcjuBlS88JCb/8ydtXRqLFsXyC8/fIcytedNbYtOXvjztuo3+/hg44P6x5FUnxcD+f9SVe3PTplj1osNiwTOfEYuOPHzGddae+s4Y/8vPt8Lv6LWfjr6RkR2WXX3SyTHxd9+M/r33jhXXfjpi0aJtlln73vfF+DXXdgz9K669Jvrvepdtlpv67e9i5dOfGcWbfhce8sJY8trXdNVftwtt+cEPYv1Hz4+Jf/rnHVYpfngteMbTY/HLTozGsmUzbnLqt7+NDRdeHONf/FI0N2zYdrnBwRh61CNjyctObP1wmumz4YILY/L/fhlLT31rxzfuFm/uXff+D0RMbomlp76921YtR4AAAQIECMxCQOifBZZFtxVY+9a3x6Zv/n3rjHhs2RJT69ZtXWBgoHWGtxERjaVLYvmHz4n+u911m5VvC/2NRmuZRl//1n+fnIzm+vXRnJqK/jvdKUY/95loDAx0pN94+ZWx7qyzIxqN2OPLX4i+Gc6gT3zr27H6xJdFTE3Fwuc+J5a8+Y3bbLs4M77yuS9o/XeLTzg+Fh33kh1qr3vP+2LjX2wN/a0+p9m/xoIFMXLFx6NvjxXbbv83v41Vz3hWK/QveOHBsfT1r+3YW7cLbPnRj2Ls2BNaf0Vo9PdF/73vHUOPeXRM/erXselvvn5bgO/bc8/Wj5lpz8JPTcXYscfH5u98d2vZoaEYvNe9IoYGY8u//0cUP66i2Yy+vfaMFdddu8NfQW7d1w0XXxLrP3JeLD72JbHohONac5npM/6lL8e6t749Fjz9z2PJ297abbuWI0CAAAECBGYhIPTPAsui0whMTbX+y+bGjXHT458UMTERi4qgd/yxrdDf+vRtd4lLRNwa+gf+6L4x+vHLoli42dpQs/UXgOIHRfFZ/IqXxaKjj2pLP7VqVYwdfUxM/vx/W8stOvaYWHziCdOu09w0EWNHHR1b/uM/o7F0aYxedUX0/8EfbF12y5ZYffyJMfGd77aC/MhVV8bAve65w3ZuDf1FaB795FXRf8e9d6xVhNxpgu7kPIX+wn/VkUfH5H/9d/Td8Y6x9G1vjsEHP/i2HyRTN90U6887P8av+1w0Fi+OZae/L4Ye/rBt93tqKta+7dQY/8IXW/u+8DnPjoVHH9n68VX8v6dWrozxa/4i1l94cetH0+Cf/HEs/+i5re1t/7k19Bc/fpa997TWZVLTfYpLnYpjodj/hc96htDvf2QIECBAgMA8CQj98wSbbrObN8fvHnNQxKZNsfhlL41FxxzdluDW0D90wAGx/JILt1222NYjH9MK4UMPfXAsP/+8ttva9JWvxpo3vrn1g6H49P/BnWPFZ/4iYnBw2vW2/PBHrR8JxV8Tlrz+tbHw4K1n9rf88Iex6tgTWj0MP/6gWPaB06dd/9bQ37dsWYxe88kozpx3+5mv0L/x0o/Hug+f29qNpe88NRY87c+nD9n/9M8xdMD9I7a7x6LV/3/8R6w6+iUR4+MxeMD9Y/nHzovGNIZrT3tPjF97XesHxbIzPti63Gem0F/8940li2Pk45fGwB/+4TaLTf3mtzH2kmNj8he/bP33Qn+3R5HlCBAgQIDA7AWE/tmbWWM6gbkM/Vu2xO8e9djWXw0GHnBAjF683Y+C29Uvrjlf9bwXxOSvf9O61KR1+cnUVCw65sWta9dn+rTO6H/r29F/5zu1LlMpfiAU15Vv/NSnW2euV3zuM9G3YttLc27d1m1n+hcv3vqXgrtse91+a7kZLmeZj9Bf9Dx2zLGx5d9+HP13Ln7wXNO6LGe2n+KSpXXvfX8UZ+dXfP6zM/bfun/iOc+PyV/9asb7Em4903/rPgzse59Yft5Ho29keeu/aq5e3boUacvtbuYW+mc7McsTIECAAIHuBYT+7q0s2U5gJ0P/wB/vH6OXXPT7kDw5GeNf/kqsffs7WtUWHn5oLDn5VdNXbjajdS3/2ee0/r24Pr+4/GRLcXPxwEDs8dnPRN+d7zTtuhs/c12se/d7tq73mlfH8BMfHyuf9dzW9fDDT31yLDvt3TN2u801/cNDEf233I9wyxqNgcEY/ey1094kPC+hf2wsVh1xdEz+3/+1ntCz5I1v2Kljdd2HzoiNn7g6Bvbbr/Vjpt1nzatfG5tu+EYMPeQhsfxjH91h0e1Df7HA8BOesPXG3gULYt073hXjn/+rbdYT+ndqbFYiQIAAAQJdCQj9XTFZqKPATob+4gx765r61pnxZussffGEm+Ia78by5bGiCM/Lt54d3v5TnOUfO+qY1tnigXvesxVUt/z432PVUS9uLdr2foANG+Lmpz4tptaujf597h79d7tbTPzt37XWW/6Rc2Lo4Q/vKvTPtNAeX/h869r67T/zEvpXrYqVRxwdU7/4RSw89JBY8pqTO45rugVu/UvH4P3vFyOXXtx2G2vf+ObWj7PBBz4gRi66YMbQXzwlaHDffWPiW99qLVM8saixcFFsuOzjrZu2Fzz1yTHx//4hplavcXnPTk3NSgQIECBAoDsBob87J0t1EtjZ0D/DdoubRxef8voYfvSjZqy86YtfijVveVsUj/hc+t7TYvjxj2stO3bCS2PzP38r+opHbl7zyRmfFV88unPtO951270AxbrFI0JHL7tkh7P3t9+J2y7vWbAglrz1zTveyNs/EIP3+5Np93teQv/tf/zsu2+MfuLyjo/JnG7nNl75iVh3xlmtdwes+MLnW38tmekzdugRUTxXv3gE6NJT3zZj6O/bY48YufD8WPeBD8XEP/zjNsu1Lvk5+8xY9YIXxdQaob/TV8y/EyBAgACBXgSE/l70rPt7gZ0M/cUTdJa+7jXR7OuL8b+4NjZ/93utbY5efmn077//1seBTvMpzvKvfOJTYmrjxlZAH3rEw6PvlhdBbf7Rj37/JJ/DD4vFJ580/TbWr49Vhx0Rkz/7eevfG319MXr1la1HXbb77Io38q59/+kx/qlrWl7Lz/tIDD70IdO3MD7eurxmus/mf/1OjL305VufwPSKl8XiGZ6aVLy4rLgnoqi17LR3xdCTn9Q29I9eeXnr31cdfmQUTxEqPsUjVYt7D4onIN184OOFfv9bQoAAAQIE5llA6J9n4DSb38nQP/iAA2Lklht1i6e4jL34JVG8Ebd/jz1aT/Xpv+u2z/e/1XPjVVfHug+e0ZG3sWI0VhTPyy8eO7n9p9ls3Q9Q3BdQfAbu9ycxUjyxZpon29x+1bkK/QtfdHAsed3sntPf3LJl2vcCFC/UWnXY1lA9cN/9Wo/kvO1RpMWFU5smYuMnPxXFS7MG7nmPWHTSK2PoQQ/cRqS4n2H1y16x9Rn9xZN53vPuGH7C47dZpvhhUFzPX5yZL24aLp7Ks/27CIoVbr2mvzjTX4T+vr33at1ovPrk10TxiNWRc86KwYf9aWvbQn/Hw9gCBAgQIECgZwGhv2dCG2gJ7GTo3/6RnZu/+93WU12K672Hn/iEWPbe90T0bXe2f2oqVh1yWOuG3b7RkRh66J9G85bHdd46jeb6dVsvJykey/naV8fCQ1407aAmf/vbWPnnz2jVK26ALW6E7fS57Ubevr7Wy6+me8pP8cNhyStfvsOjMW9/eU9xr8LQ4w7a4Uk/xV8cFp14fOutwbf1s3FjrHnt61s3645+4oppL1ka/8pXt77fYPPm1uU9i487NoYOOjCmbvpdbLjo0tj8ne9s3VzxdJ6rrmzdy7DD76D162Plc5/fuq+i+BQzWFTYDQ62nt8//ulrovXDY+GCGLns0hi4972m5Zou9LcOk+L6/YmJGD7wsbetJ/R3OuL8OwECBAgQ6F1A6O/d0BaKM8kTE3HzYw5q/WfxqMzikZntPsVz9TcVN4IecP8YKZ7ec7vP+nM/EhsuuWxrcC1e9HXsMdtcoz5+7Wdi7Xve1zrjvfT098XwdC9+mpqKNa8/JTZ9/fpWeB695lPRt+L3IXqbemefE5u+9jcx+qmro7FoUcd5rjvtvbHx2s+0X25goPXW2+3/UlGckV/59K1v5G33KV5oNXy7y2aKm5XHXnxsNNeti6WnvTMWPPWpO64+ORmbvv71WH/m2a1HmE73GXzwg2LJG17fOts/06d48+66970/Nn//B9MuUtxvsfTtb535EqKIWH/BhbHh/AuidU3/lR+P/r2neYHZLVu/6bGPi+batTPeH9BxIBYgQIAAAQIEOgoI/R2JLNCVQLMZ6z/woZi6+aZY8LznxeBDHtx2teJxjRPf/PvWJTWLDj1km2WL6/XXnXNuNFetiuLpL0te9cpt3vq69t3vaYXE4uk4S4pn8c/wTPot//0/seHCi6I5NRmLDj44Bre7nOXWopO/+U1M/fznMfiQGa6D366T4i8I45/9XNv+GkNDrRuR+7Z7W23xjPviWfjF04lm+hRn+hef9Mrou/2bfic2R/FIzeLZ+Ms+eHoU25/pM3Xzyth4+eUx8U//HFPrN0Sjvy/699orFjz72TH8pCe0vUn5tm02mzH+ub+M8es+G1Njq1s3OzcWL2r9EFl02KFtb/IttlG8AG3DFVdGY2Qklpz0irY/ptad8+HWXzAWPPGJrb8s+BAgQIAAAQJzLyD0z72pLRKYH4HiEqapqe5Ce/HXl/Hx1v8pfkQULxzb/n0C3exkcSlPbNjQunyqb+GiiKHp33LczbYsQ4AAAQIECFQnIPRXZ68yAQIECBAgQIAAgVIEhP5SmBUhQIAAAQIECBAgUJ2A0F+dvcoECBAgQIAAAQIEShEQ+kthVoQAAQIECBAgQIBAdQJCf3X2KhMgQIAAAQIECBAoRUDoL4VZEQIECBAgQIAAAQLVCQj91dmrTIAAAQIECBAgQKAUAaG/FGZFCBAgQIAAAQIECFQnIPRXZ68yAQIECBAgQIAAgVIEhP5SmBUhQIAAAQIECBAgUJ2A0F+dvcoECBAgQIAAAQIEShEQ+kthVoQAAQIECBAgQIBAdQJCf3X2KhMgQIAAAQIECBAoRUDoL4VZEQIECBAgQIAAAQLVCQj91dmrTIAAAQIECBAgQKAUAaG/FGZFCBAgQIAAAQIECFQnIPRXZ68yAQIECBAgQIAAgVIEhP5SmBUhQIAAAQIECBAgUJ2A0F+dvcoECBAgQIAAAQIEShEQ+kthVoQAAQIECBAgQIBAdQJCf3X2KhMgQIAAAQIECBAoRUDoL4VZEQIECBAgQIAAAQLVCQj91dmrTIAAAQIECBAgQKAUAaG/FGZFCBAgQIAAAQIECFQnIPRXZ68yAQIECBAgQIAAgVIEhP5SmBUhQIAAAQIECBAgUJ2A0F+dvcoECBAgQIAAAQIEShEQ+kthVoQAAQIECBAgQIBAdQJCf3X2KhMgQIAAAQIECBAoRUDoL4VZEQIECBAgQIAAAQLVCQj91dmrTIAAAQIECBAgQKAUAaG/FGZFCBAgQIAAAQIECFQnIPRXZ68yAQIECBAgQIAAgVIEhP5SmBUhQIAAAQIECBAgUJ2A0F+dvcoECBAgQIAAAQIEShEQ+kthVoQAAQIECBAgQIBAdQJCf3X2KhMgQIAAAQIECBAoRUDoL4VZEQIECBAgQIAAAQLVCQj91dmrTIAAAQIECBAgQKAUAaG/FGZFCBAgQIAAAQIECFQnIPRXZ68yAQIECBAgQIAAgVIEhP5SmBUhQIAAAQIECBAgUJ2A0F+dvcoECBAgQIAAAQIEShEQ+kthVoQAAQIECBAgQIBAdQJCf3X2KhMgQIAAAQIECBAoRUDoL4VZEQIECBAgQIAAAQLVCQj91dmrTIAAAQIECBAgQKAUAaG/FGZFCBAgQIAAAQIECFQnIPRXZ68yAQIECBAgQIAAgVIEhP5SmBUhQIAAAQIECBAgUJ2A0F+dvcoECBAgQIAAAQIEShEQ+kthVoQAAQIECBAgQIBAdQJCf3X2KhMgQIAAAQIECBAoRUDoL4VZEQIECBAgQIAAAQLVCQj91dmrTIAAAQIECBAgQKAUAaG/FGZFCBAgQIAAAQIECFQnIPRXZ68yAQIECBAgQIAAgVIEhP5SmBUhQIAAAQIECBAgUJ2A0F+dvcoECBAgQIAAAQIEShEQ+kthVoQAAQIECBAgQIBAdQJCf3X2KhMgQIAAAQIECBAoRUDoL4VZEQIECBAgQIAAAQLVCQj91dmrTIAAAQIECBAgQKAUAaG/FGZFCBAgQIAAAQIECFQnIPRXZ68yAQIECBAgQIAAgVIEhP5SmBUhUA+BG2+8MS677LJ6NKMLAru5wFFHHRX77LPPbt6F3SdAoCwBob8saXUI1EDgu9/9bpx88sk16EQLBHZ/gTPPPDMOOOCA3b8RHRAgUIqA0F8KsyIECBAgQIAAAQIEqhMQ+quzV5kAAQIECBAgQIBAKQJCfynMihAgQIAAAQIECBCoTkDor85eZQIECBAgQIAAAQKlCAj9pTArQoAAAQIECBAgQKA6AaG/OnuVCRAgQIAAAQIECJQiIPSXwqwIAQIECBAgQIAAgeoEhP7q7FUmQIAAAQIECBAgUIqA0F8KsyIECBAgQIAAAQIEqhMQ+quzV5kAAQIECBAgQIBAKQJCfynMihAgQIAAAQIECBCoTkDor85eZQIECBAgQIAAAQKlCAj9pTArQoAAAQIECBAgQKA6AaG/OnuVCRAgQIAAAQIECJQiIPSXwqwIAQIECBAgQIAAgeoEhP7q7FUmQIAAAQIECBAgUIqA0F8KsyIECBAgQIAAAQIEqhMQ+quzV5kAAQIECBAgQIBAKQJCfynMihAgQIAAAQIECBCoTkDor85eZQIECBAgQIAAAQKlCAj9pTArQoAAAQIECBAgQKA6AaG/OnuVCRAgQIAAAQIECJQiIPSXwqwIAQIECBAgQIAAgeoEhP7q7FUmQIAAAQIECBAgUIqA0F8KsyIECBAgQIAAAQIEqhMQ+quzV5kAAQIECBAgQIBAKQJCfynMihAgQIAAAQIECBCoTkDor85eZQIECBAgQIAAAQKlCAj9pTArQoAAAQIECBAgQKA6AaG/OnuVCRAgQIAAAQIECJQiIPSXwqwIAQIECBAgQIAAgeoEhP7q7FUmQIAAAQIECBAgUIqA0F8KsyIECBAgQIAAAQIEqhMQ+quzV5kAAQIECBAgQIBAKQJCfynMihAgQIAAAQIECBCoTkDor85eZQIECBAgQIAAAQKlCAj9pTArQoAAAQIECBAgQKA6AaG/OnuVCRAgQIAAAQIECJQiIPSXwqwIAQIECBAgQIAAgeoEhP7q7FUmQIAAAQIECBAgUIqA0F8KsyIECBAgQIAAAQIEqhMQ+quzV5kAAQIECBAgQIBAKQJCfynMihAgQIAAAQIECBCoTkDor85eZQIECBAgQIAAAQKlCAj9pTArQoAAAQIECBAgQKA6AaG/OnuVCRAgQIAAAQIECJQiIPSXwqwIAQIECBAgQIAAgeoEhP7q7FUmQIAAAQIECBAgUIqA0F8KsyIECBAgQIAAAQIEqhMQ+quzV5kAAQIECBAgQIBAKQJCfynMihAgQIAAAQIECBCoTkDor85eZQIECBAgQIAAAQKlCAj9pTArQoAAAQIECBAgQKA6AaG/OnuVCRAgQIAAAQIECJQiIPSXwqwIAQIECBAgQIAAgeoEhP7q7FUmQIAAAQIECBAgUIqA0F8KsyIECBAgQIAAAQIEqhMQ+quzV5kAAQIECBAgQIBAKQJCfynMihAgQIAAAQIECBCoTkDor85eZQIECBAgQIAAAQKlCAj9pTArQoAAAQIECBAgQKA6AaG/OnuVCRAgQIAAAQIECJQiIPSXwqwIAQIECBAgQIAAgeoEhP7q7FUmQIAAAQIECBAgUIqA0F8KsyIECBAgQIAAAQIEqhMQ+quzV5kAAQIECBAgQIBAKQJCfynMihAgQIAAAQIECBCoTkDor85eZQIECBAgQIAAAQKlCAj9pTArQoAAAQIECBAgQKA6AaG/OnuVCRAgQIAAAQIECJQiIPSXwqwIAQIECBAgQIAAgeoEhP7q7FUmQIAAAQIECBAgUIqA0F8KsyIECBAgQIAAAQIEqhMQ+quzV5kAAQIECBAgQIBAKQJCfynMihAgQIAAAQIECBCoTkDor85eZQIECBAgQIAAAQKlCAj9pTArQoAAAQIECBAgQKA6AaG/OnuVCRAgQIAAAQIECJQiIPSXwqwIAQIECBAgQIAAgeoEhP7q7FUmQIAAAQIECBAgUIqA0F8KsyIECBAgQIAAAQIEqhMQ+quzV5kAAQIECBAgQIBAKQJCfynMihAgQIAAAQIECBCoTkDor85eZQIECBAgQIAAAQKlCAj9pTArQoAAAQIECBAgQKA6AaG/OnuVCRAgQIAAAQIECJQiIPSXwqwIAQIECBAgQIAAgeoEhP7q7FUmQIAAAQIECBAgUIqA0F8KsyIECBAgQIAAAQIEqhMQ+quzV5kAAQIECBAgQIBAKQJCfynMihAgQIAAAQIECBCoTkDor85eZQIECBAgQIAAAQKlCAj9pTArQoAAAQIECBAgQKA6AaG/OnuVCRAgQIAAAQIECJQiIPSXwqwIAQIECBAgQIAAgeoEhP7q7FUmQIAAAQIECBAgUIqA0F8KsyIECBAgQIAAAQIEqhMQ+quzV5kAAQIECBAgQIBAKQJCfynMihAgQIAAAQIECBCoTkDor85eZQIECBAgQIAAAQKlCAj9pTArQoAAAQIECBAgQKA6AaG/OnuVCRAgQIAAAQIECJQiIPSXwqwIAQIECBAgQIAAgeoEhP7q7FUmQIAAAQIECBAgUIqA0F8KsyIECBAgQIAAAQIEqhMQ+quzV5kAAQIECBAgQIBAKQJCfynMihAgQIAAAQIECBCoTkDor85eZQIECBAgQIAAAQKlCAj9pTArQoAAAQIECBAgQKA6AaG/OnuVCRAgQIAAAQIECJQiIPSXwqwIAQIECBAgQIAAgeoEhP7q7FUmQIAAAQIECBAgUIqA0F8KsyIECBAgQIAAAQIEqhMQ+quzV5kAAQIECBAgQIBAKQJCfynMihAgQIAAAQIECBCoTkDor85eZQIECBAgQIAAAQKlCAj9pTArQoAAAQIECBAgQKA6AaG/OnuVCRAgQIAAAQIECJQiIPSXwqwIAQIECBAgQIAAgeoEhP6S7G+44YaSKilDgAABAgRmFjjwwAPxECCQUEDoL2nojUajpErKECBAgACBmQWazSYeAgQSCgj9CYeuZQIECBAgQIAAgVwCQn+ueeuWAAECBAgQIEAgoYDQn3DoWiZAgAABAgQIEMglIPTnmrduCRAgQIAAAQIEEgoI/QmHrmUCBAgQIECAAIFcAkJ/rnnrlgABAgQIECBAIKGA0J9w6FomQIAAAQIECBDIJSD055q3bgkQIECAAAECBBIKCP0Jh65lAgQIECBAgACBXAJCf65565YAAQIECBAgQCChgNCfcOhaJkCAAAECBAgQyCUg9Oeat24JECBAgAABAgQSCgj9CYeuZQIECBAgQIAAgVwCQn+ueeuWAAECBAgQIEAgoYDQn3DoWiZAgAABAgQIEMglIPTnmrduCRAgQIAAAQIEEgoI/QmHrmUCBAgQIECAAIFcAkJ/rnnrlgABAgQIECBAIKGA0J9w6FomQIAAAQIECBDIJSD055q3bgkQIECAAAECBBIKCP0Jh65lAgQIECBAgACBXAJCf65565YAAQIECBAgQCChgNCfcOhaJkCAAAECBAgQyCUg9Oeat24JECBAgAABAgQSCgj9CYeuZQIECBAgQIAAgVwCQn+ueeuWAAECBAgQIEAgoYDQn3DoWiZAgAABAgQIEMglIPTnmrduCRAgQIAAAQIEEgoI/QmHrmUCBAgQIECAAIFcAkJ/rnnrlgABAgQIECBAIKGA0J9w6FomQIAAAQIECBDIJSD055q3bgkQIECAAAECBBIKCP0Jh65lAgQIECBAgACBXAJCf65565YAAQIECBAgQCChgNCfcOhaJkCAAAECBAgQyCUg9Oeat24JECBAgAABAgQSCgj9CYeuZQIECBAgQIAAgVwCQn+ueeuWAAECBAgQIEAgoYDQn3DoWiZAgAABAgQIEMglIPTnmrduCRAgQIAAAQIEEgoI/QmHrmUCBAgQIECAAIFcAkJ/rnnrlgABAgQIECBAIKGA0J9w6FomQIAAAQIECBDIJSD055q3bgkQIECAAAECBBIKCP0Jh65lAgQIECBAgACBXAJCf65565YAAQIECBAgQCChgNCfcOhaJkCAAAECBAgQyCUg9Oeat24JECBAgAABAgQSCgj9CYeuZQIECBAgQIAAgVwCQn+ueeuWAAECBAgQIEAgoYDQn3DoWiZAgAABAgQIEMglIPTnmrduCRAgQIAAAQIEEgoI/QmHrmUCBAgQIECAAIFcAkJ/rnnrlgABAgQIECBAIKGA0J9w6FomQIAAAQIECBDIJSD055q3bgkQIECAAAECBBIKCP0Jh65lAgQIECBAgACBXAJCf65565YAAQIECBAgQCChgNCfcOhaJkCAAAECBAgQyCUg9Oeat24JECBAgAABAgQSCgj9CYeuZQIECBAgQIAAgVwCQn+ueeuWAAECBAgQIEAgoYDQn3DoWiZAgAABAgQIEMglIPTnmrduCRAgQIAAAQIEEgoI/QmHrmUCBAgQIECAAIFcAkJ/rnnrlgABAgQIECBAIKGA0J9w6FomQIAAAQvn8VQAACAASURBVAIECBDIJSD055q3bgkQIECAAAECBBIKCP0Jh65lAgQIECBAgACBXAJCf65565YAAQIECBAgQCChgNCfcOhaJkCAAAECBAgQyCUg9Oeat24JECBAgAABAgQSCgj9CYeuZQIECBAgQIAAgVwCQn+ueeuWAAECBAgQIEAgoYDQn3DoWiZAgAABAgQIEMglIPTnmrduCRAgQIAAAQIEEgoI/QmHrmUCBAgQIECAAIFcAkJ/rnnrlgABAgQIECBAIKGA0J9w6FomQIAAAQIECBDIJSD055q3bgkQIECAAAECBBIKCP0Jh65lAgQIECBAgACBXAJCf65565YAAQIECBAgQCChgNCfcOhaJkCAAAECBAgQyCUg9Oeat24JECBAgAABAgQSCgj9CYeuZQIECBAgQIAAgVwCQn+ueeuWAAECBAgQIEAgoYDQn3DoWiZAgAABAgQIEMglIPTnmrduCRAgQIAAAQIEEgoI/QmHrmUCBAgQIECAAIFcAkJ/rnnrlgABAgQIECBAIKGA0J9w6FomQIAAAQIECBDIJSD055q3bgkQIECAAAECBBIKCP0Jh65lAgQIECBAgACBXAJCf65565YAAQIECBAgQCChgNCfcOhaJkCAAAECBAgQyCUg9Oeat24JECBAgAABAgQSCgj9CYeuZQIECBAgQIAAgVwCQn+ueeuWAAECBAgQIEAgoYDQn3DoWiZAgAABAgQIEMglIPTnmrduCRAgQIAAAQIEEgoI/QmHrmUCBAgQIECAAIFcAkJ/rnnrlgABAgQIECBAIKGA0J9w6FomQIAAAQIECBDIJSD055q3bgkQIECAAAECBBIKCP0Jh65lAgQIECBAgACBXAJCf65565YAAQIECBAgQCChgNCfcOhaJkCAAAECBAgQyCUg9Oeat24JECBAgAABAgQSCgj9CYeuZQIECBAgQIAAgVwCQn+ueeuWAAECBAgQIEAgoYDQn3DoWiZAgAABAgQIEMglIPTnmrduCRAgQIAAAQIEEgoI/QmHrmUCBAgQIECAAIFcAkJ/rnnrlgABAgQIECBAIKGA0J9w6FomQIAAAQIECBDIJSD055q3bgkQIECAAAECBBIKCP0Jh65lAgQIECBAgACBXAJCf65565YAAQIECBAgQCChgNCfcOhaJkCAAAECBAgQyCUg9Oeat24JECBAgAABAgQSCgj9CYeuZQIECBAgQIAAgVwCQn+ueeuWAAECBAgQIEAgoYDQn3DoWiZAgAABAgQIEMglIPTnmrduCRAgQIAAAQIEEgoI/QmHrmUCBAgQIECAAIFcAkJ/rnnrlgABAgQIECBAIKGA0J9w6FomQIAAAQIECBDIJSD055q3bgkQIECAAAECBBIKCP0Jh65lAgQIECBAgACBXAJCf65565YAAQIECBAgQCChgNCfcOhaJkCAAAECBAgQyCUg9Oeat24JECBAgAABAgQSCgj9CYeuZQIECBAgQIAAgVwCQn+ueeuWAAECBAgQIEAgoYDQn3DoWiZAgAABAgQIEMglIPTnmrduCRAgQIAAAQIEEgoI/QmHrmUCBAgQIECAAIFcAkJ/rnnrlgABAgQIECBAIKGA0J9w6FomQIAAAQIECBDIJSD055q3bgkQIECAAAECBBIKCP0Jh65lAgQIECBAgACBXAJCf65565YAAQIECBAgQCChgNCfcOhaJkCAAAECBAgQyCUg9Oeat24JECBAgAABAgQSCgj9CYeuZQIECBAgQIAAgVwCQn+ueeuWAAECBAgQIEAgoYDQn3DoWiZAgAABAgQIEMglIPTnmrduCRAgQIAAAQIEEgoI/QmHrmUCBAgQIECAAIFcAkJ/rnnrlgABAgQIECBAIKGA0J9w6FomQIAAAQIECBDIJSD055q3bgkQIECAAAECBBIKCP0Jh65lAgQIECBAgACBXAJCf65565YAAQIECBAgQCChgNCfcOhaJkCAAAECBAgQyCUg9Oeat24JECBAgAABAgQSCgj9CYeuZQIECBAgQIAAgVwCQn+ueeuWAAECBAgQIEAgoYDQn3DoWiZAgAABAgQIEMglIPTnmrduCRAgQIAAAQIEEgoI/QmHrmUCBAgQIECAAIFcAkJ/rnnrlgABAgQIECBAIKGA0J9w6FomQIAAAQIECBDIJSD055q3bgkQIECAAAECBBIKCP0Jh65lAgQIECBAgACBXAJCf0nzbjQaJVVSZnuBZrMJhQABAgQIECCQWkDoL2n8N9xwQ0mVlNle4MADD4RCgAABAgQIEEgtIPSnHr/mCRAgQIAAAQIEMggI/RmmrEcCBAgQIECAAIHUAkJ/6vFrngABAgQIECBAIIOA0J9hynokQIAAAQIECBBILSD0px6/5gkQIECAAAECBDIICP0ZpqxHAgQIECBAgACB1AJCf+rxa54AAQIECBAgQCCDgNCfYcp6JECAAAECBAgQSC0g9Kcev+YJECBAgAABAgQyCAj9GaasRwIECBAgQIAAgdQCQn/q8WueAAECBAgQIEAgg4DQn2HKeiRAgAABAgQIEEgtIPSnHr/mCRAgQIAAAQIEMggI/RmmrEcCBAgQIECAAIHUAkJ/6vFrngABAgQIECBAIIOA0J9hynokQIAAAQIECBBILSD0px6/5gkQIECAAAECBDIICP0ZpqxHAgQIECBAgACB1AJCf+rxa54AAQIECBAgQCCDgNCfYcp6JECAAAECBAgQSC0g9Kcev+YJECBAgAABAgQyCAj9GaasRwIECBAgQIAAgdQCQn/q8WueAAECBAgQIEAgg4DQn2HKeiRAgAABAgQIEEgtIPSnHr/mCRAgQIAAAQIEMggI/RmmrEcCBAgQIECAAIHUAkJ/6vFrngABAgQIECBAIIOA0J9hynokQIAAAQIECBBILSD0px6/5gkQIECAAAECBDIICP0ZpqxHAgQIECBAgACB1AJCf+rxa54AAQIECBAgQCCDgNCfYcp6JECAAAECBAgQSC0g9Kcev+YJECBAgAABAgQyCAj9GaasRwIECBAgQIAAgdQCQn/q8WueAAECBAgQIEAgg4DQn2HKeiRAgAABAgQIEEgtIPSnHr/mCRAgQIAAAQIEMggI/RmmrEcCBAgQIECAAIHUAkJ/6vFrngABAgQIECBAIIOA0J9hynokQIAAAQIECBBILSD0px6/5gkQIECAAAECBDIICP0ZpqxHAgQIECBAgACB1AJCf+rxa54AAQIECBAgQCCDgNCfYcp6JECAAAECBAgQSC0g9Kcev+YJECBAgAABAgQyCAj9GaasRwIECBAgQIAAgdQCQn/q8WueAAECBAgQIEAgg4DQn2HKeiRAgAABAgQIEEgtIPSnHr/mCRAgQIAAAQIEMggI/RmmrEcCBAgQIECAAIHUAkJ/6vFrngABAgQIECBAIIOA0J9hynokQIAAAQIECBBILSD0px6/5gkQIECAAAECBDIICP0lTbnRaJRUSRkCBAgQIECAwO4lcP3118eBBx64e+30bra3Qn9JAytC/5lnnhkHHHBASRWVqYPAZZddFt/73vdax44PAQK7l4Dv7+41L3tbncBBBx0UQv/8+wv982/cqlCEfgd0Sdg1KnPqqafGN77xjdax40OAwO4l4Pu7e83L3lYnICOVYy/0l+Ms9JfkXLcyQkPdJqqfTAK+v5mmrddeBIT+XvS6X1fo796qpyUd0D3xpV1ZaEg7eo3XQMD3twZD1EIpAjJSKcwh9Jfj7Ex/Sc51KyM01G2i+skk4Pubadp67UVA6O9Fr/t1hf7urXpa0gHdE1/alYWGtKPXeA0EfH9rMEQtlCIgI5XC7Ex/Ocxu5C3LuW51hIa6TVQ/mQR8fzNNW6+9CAj9veh1v64z/d1b9bSkA7onvrQrCw1pR6/xGgj4/tZgiFooRUBGKoXZmf5ymJ3pL8u5bnWEhrpNVD+ZBHx/M01br70ICP296HW/rjP93Vv1tKQDuie+tCsLDWlHr/EaCPj+1mCIWihFQEYqhdmZ/nKYnekvy7ludYSGuk1UP5kEfH8zTVuvvQgI/b3odb+uM/3dW/W0pAO6J760KwsNaUev8RoI+P7WYIhaKEVARiqF2Zn+cpid6S/LuW51hIa6TVQ/mQR8fzNNW6+9CAj9veh1v64z/d1b9bSkA7onvrQrCw1pR6/xGgj4/tZgiFooRUBGKoXZmf5ymJ3pL8u5bnWEhrpNVD+ZBHx/M01br70ICP296HW/rjP93Vv1tKQDuie+tCsLDWlHr/EaCPj+1mCIWihFQEYqhdmZ/nKYnekvy7ludYSGuk1UP5kEfH8zTVuvvQgI/b3odb+uM/3dW/W0pAO6J760KwsNaUev8RoI+P7WYIhaKEVARiqF2Zn+cpid6S/LuW51hIa6TVQ/mQR8fzNNW6+9CAj9veh1v64z/d1b9bSkA7onvrQrCw1pR6/xGgj4/tZgiFooRUBGKoXZmf5ymJ3pL8u5bnWEhrpNVD+ZBHx/M01br70ICP296HW/rjP93Vv1tKQDuie+tCsLDWlHr/EaCPj+1mCIWihFQEYqhdmZ/nKYnekvy7ludYSGuk1UP5kEfH8zTVuvvQgI/b3odb+uM/3dW/W0pAO6J760KwsNaUev8RoI+P7WYIhaKEVARiqF2Zn+cpid6S/LuW51hIa6TVQ/mQR8fzNNW6+9CAj9veh1v64z/d1b9bSkA7onvrQrCw1pR6/xGgj4/tZgiFooRUBGKoXZmf5ymLee6T/yyCNjn3322aZk8d83m822u9HNMmX1oU65AjfccEP87Gc/ax07PgRuFejmfxO6WYbo/Ar4/s6vr63XR+Ad73hHXH/99XHggQfWp6ldsBNn+ksaSvH/AR9wwAExMjJSUkVl6iBw4403xtjYWOvY8SFAYPcS8P3dveZlb6sTKH4gC/3z7y/0z79xq4I/XZUEXbMyLg+o2UC1k0rA9zfVuDXbg4CM1APeLFYV+meB1cuiDuhe9PKuKzTknb3Od38B39/df4Y6KEdARirJudnpgvJy9qP2VRzQtR/xvDQoNMwLq40SKEXA97cUZkVqICAjlTNEZ/rLcXZ5T0nOdSsjNNRtovrJJOD7m2naeu1FQOjvRa/7dYX+7q16WtIB3RNf2pWFhrSj13gNBHx/azBELZQiICOVwuyRneUwu5G3LOe61REa6jZR/WQS8P3NNG299iIg9Pei1/26zvR3b9XTkg7onvjSriw0pB29xmsg4PtbgyFqoRQBGakUZmf6y2F2pr8s57rVERrqNlH9ZBLw/c00bb32IiD096LX/brO9Hdv1dOSDuie+NKuLDSkHb3GayDg+1uDIWqhFAEZqRRmZ/rLYXamvyznutURGuo2Uf1kEvD9zTRtvfYiIPT3otf9us70d2/V05IO6J740q4sNKQdvcZrIOD7W4MhaqEUARmpFGZn+sthdqa/LOe61REa6jZR/WQS8P3NNG299iIg9Pei1/26zvR3b9XTkg7onvjSriw0pB29xmsg4PtbgyFqoRQBGakUZmf6y2F2pr8s57rVERrqNlH9ZBLw/c00bb32IiD096LX/brO9Hdv1dOSDuie+NKuLDSkHb3GayDg+1uDIWqhFAEZqRRmZ/rLYXamvyznutURGuo2Uf1kEvD9zTRtvfYiIPT3otf9us70d2/V05IO6J740q4sNKQdvcZrIOD7W4MhaqEUARmpFGZn+sthdqa/LOe61REa6jZR/WQS8P3NNG299iIg9Pei1/26zvR3b9XTkg7onvjSriw0pB29xmsg4PtbgyFqoRQBGakUZmf6y2F2pr8s57rVERrqNlH9ZBLw/c00bb32IiD096LX/brO9Hdv1dOSDuie+NKuLDSkHb3GayDg+1uDIWqhFAEZqRRmZ/rLYXamvyznutURGuo2Uf1kEvD9zTRtvfYiIPT3otf9us70d2/V05IO6J740q4sNKQdvcZrIOD7W4MhaqEUARmpFGZn+sthdqa/LOe61REa6jZR/WQS8P3NNG299iIg9Pei1/26zvR3b9XTkg7onvjSriw0pB29xmsg4PtbgyFqoRQBGakUZmf6y2F2pr8s57rVERrqNlH9ZBLw/c00bb32IiD096LX/brO9Hdv1dOSDuie+NKuLDSkHb3GayDg+1uDIWqhFAEZqRRmZ/rLYd56pv+AAw6IkZGRskqqUwOBG2+8McbGxlrHjg8BAruXgO/v7jUve1udwA033BDXX399HHjggdXtRILKzvSXNOSDDjoo7n//+wv9JXnXpYzQUJdJ1quP4iRGp0+z2ey0SM//3mk/ytiHoomZ9qP4/q5ataqUH+3tLObbYS5q37qNnd3XXXkfZtPT7fuYzXq3fplmcpjNtrbfxmzWnen70GkbRc0jjzwy9tlnn57/d8EGZhYQ+h0dBAgQIECAAAECBGouIPTXfMDaI0CAAAECBAgQICD0OwYIECBAgAABAgQI1FxA6K/5gLVHgAABAgQIECBAQOh3DBAgQIAAAQIECBCouYDQX/MBa48AAQIECBAgQICA0O8YIECAAAECBAgQIFBzAaG/5gPWHgECBAgQIECAAAGh3zFAgAABAgQIECBAoOYCQn/NB6w9AgQIECBAgAABAkK/Y4AAAQIECBAgQIBAzQWE/poPWHsECBAgQIAAAQIEhH7HAAECBAgQIECAAIGaCwj9NR+w9ggQIECAAAECBAgI/Y4BAgQIECBAgAABAjUXEPprPmDtESBAgAABAgQIEBD6HQMECBAgQIAAAQIEai4g9Nd8wNojQIAAAQIECBAgIPQ7BggQIECAAAECBAjUXEDor/mAtUeAAAECBAgQIEBA6HcMECBAgAABAgQIEKi5gNBf8wFrjwABAgQIECBAgIDQ7xggQIAAAQIECBAgUHMBob/mA9YeAQIECBAgQIAAAaHfMUCAAAECBAgQIECg5gJCf80HrD0CBAgQIECAAAECQr9jgAABAgQIECBAgEDNBYT+mg9YewQIECBAgAABAgSEfscAAQIECBAgQIAAgZoLCP01H7D2CBAgQIAAAQIECAj9jgECBAgQIECAAAECNRcQ+ms+YO0RIECAAAECBAgQEPpLOgYajUZJlZQhsKNAs9nEQoAAAQIECCQWEPpLGv4NN9xQUiVlCOwocOCBB2IhQIAAAQIEEgsI/YmHr3UCBAgQIECAAIEcAkJ/jjnrkgABAgQIECBAILGA0J94+FonQIAAAQIECBDIISD055izLgkQIECAAAECBBILCP2Jh691AgQIECBAgACBHAJCf44565IAAQIECBAgQCCxgNCfePhaJ0CAAAECBAgQyCEg9OeYsy4JECBAgAABAgQSCwj9iYevdQIECBAgQIAAgRwCQn+OOeuSAAECBAgQIEAgsYDQn3j4WidAgAABAgQIEMghIPTnmLMuCRAgQIAAAQIEEgsI/YmHr3UCBAgQIECAAIEcAkJ/jjnrkgABAgQIECBAILGA0J94+FonQIAAAQIECBDIISD055izLgkQIECAAAECBBILCP2Jh691AgQIECBAgACBHAJCf44565IAAQIECBAgQCCxgNCfePhaJ0CAAAECBAgQyCEg9OeYsy4JECBAgAABAgQSCwj9iYevdQIECBAgQIAAgRwCQn+OOeuSAAECBAgQIEAgsYDQn3j4WidAgAABAgQIEMghIPTnmLMuCRAgQIAAAQIEEgsI/YmHr3UCBAgQIECAAIEcAkJ/jjnrkgABAgQIECBAILGA0J94+FonQIAAAQIECBDIISD055izLgkQIECAAAECBBILCP2Jh691AgQIECBAgACBHAJCf44565IAAQIECBAgQCCxgNCfePhaJ0CAAAECBAgQyCEg9OeYsy4JECBAgAABAgQSCwj9iYevdQIECBAgQIAAgRwCQn+OOeuSAAECBAgQIEAgsYDQn3j4WidAgAABAgQIEMghIPTnmLMuCRAgQIAAAQIEEgsI/YmHr3UCBAgQIECAAIEcAkJ/jjnrkgABAgQIECBAILGA0J94+FonQIAAAQIECBDIISD055izLgkQIECAAAECBBILCP2Jh691AgQIECBAgACBHAJCf44565IAAQIECBAgQCCxgNCfePhaJ0CAAAECBAgQyCEg9OeYsy4JECBAgAABAgQSCwj9iYevdQIECBAgQIAAgRwCQn+OOeuSAAECBAgQIEAgsYDQn3j4WidAgAABAgQIEMghIPTnmLMuCRAgQIAAAQIEEgsI/YmHr3UCBAgQIECAAIEcAkJ/jjnrkgABAgQIECBAILGA0J94+FonQIAAAQIECBDIISD055izLgkQIECAAAECBBILCP2Jh691AgQIECBAgACBHAJCf44565IAAQIECBAgQCCxgNCfePhaJ0CAAAECBAgQyCEg9OeYsy4JECBAgAABAgQSCwj9iYevdQIECBAgQIAAgRwCQn+OOeuSAAECBAgQIEAgsYDQn3j4WidAgAABAgQIEMghIPTnmLMuCRAgQIAAAQIEEgsI/YmHr3UCBAgQIECAAIEcAkJ/jjnrkgABAgQIECBAILGA0J94+FonQIAAAQIECBDIISD055izLgkQIECAAAECBBILCP2Jh691AgQIECBAgACBHAJCf44565IAAQIECBAgQCCxgNCfePhaJ0CAAAECBAgQyCEg9OeYsy4JECBAgAABAgQSCwj9iYevdQIECBAgQIAAgRwCQn+OOeuSAAECBAgQIEAgsYDQn3j4WidAgAABAgQIEMghIPTnmLMuCRAgQIAAAQIEEgsI/YmHr3UCBAgQIECAAIEcAkJ/jjnrkgABAgQIECBAILGA0J94+FonQIAAAQIECBDIISD055izLgkQIECAAAECBBILCP2Jh691AgQIECBAgACBHAJCf44565IAAQIECBAgQCCxgNCfePhaJ0CAAAECBAgQyCEg9OeYsy4JECBAgAABAgQSCwj9iYevdQIECBAgQIAAgRwCQn+OOeuSAAECBAgQIEAgsYDQn3j4WidAgAABAgQIEMghIPTnmLMuCRAgQIAAAQIEEgsI/YmHr3UCBAgQIECAAIEcAkJ/jjnrkgABAgQIECBAILGA0J94+FonQIAAAQIECBDIISD055izLgkQIECAAAECBBILCP2Jh691AgQIECBAgACBHAJCf44565IAAQIECBAgQCCxgNCfePhaJ0CAAAECBAgQyCEg9OeYsy4JECBAgAABAgQSCwj9iYevdQIECBAgQIAAgRwCQn+OOeuSAAECBAgQIEAgsYDQn3j4WidAgAABAgQIEMghIPTnmLMuCRAgQIAAAQIEEgsI/YmHr3UCBAgQIECAAIEcAkJ/jjnrkgABAgQIECBAILGA0J94+FonQIAAAQIECBDIISD055izLgkQIECAAAECBBILCP2Jh691AgQIECBAgACBHAJCf44565IAAQIECBAgQCCxgNCfePhaJ0CAAAECBAgQyCEg9OeYsy4JECBAgAABAgQSCwj9iYevdQIECBAgQIAAgRwCQn+OOeuSAAECBAgQIEAgsYDQn3j4WidAgAABAgQIEMghIPTnmLMuCRAgQIAAAQIEEgsI/YmHr3UCBAgQIECAAIEcAkJ/jjnrkgABAgQIECBAILGA0J94+FonQIAAAQIECBDIISD055izLgkQIECAAAECBBILCP2Jh691AgQIECBAgACBHAJCf44565IAAQIECBAgQCCxgNCfePhaJ0CAAAECBAgQyCEg9OeYsy4JECBAgAABAgQSCwj9iYevdQIECBAgQIAAgRwCQn+OOeuSAAECBAgQIEAgsYDQn3j4WidAgAABAgQIEMghIPTnmLMuCRAgQIAAAQIEEgsI/YmHr3UCBAgQIECAAIEcAkJ/jjnrkgABAgQIECBAILGA0J94+FonQIAAAQIECBDIISD055izLgkQIECAAAECBBILCP2Jh691AgQIECBAgACBHAJCf44565IAAQIECBAgQCCxgNCfePhaJ0CAAAECBAgQyCEg9OeYsy4JECBAgAABAgQSCwj9iYevdQIECBAgQIAAgRwCQn+OOeuSAAECBAgQIEAgsYDQn3j4WidAgAABAgQIEMghIPTnmLMuCRAgQIAAAQIEEgsI/YmHr3UCBAgQIECAAIEcAkJ/jjnrkgABAgQIECBAILGA0J94+FonQIAAAQIECBDIISD055izLgkQIECAAAECBBILCP2Jh691Av+/3TomAAAAYBDUv7VBJMLYIwECBAgQIEDgISD6Hz9bSYAAAQIECBAgMBYQ/ePzTSdAgAABAgQIEHgIiP7Hz1YSIECAAAECBAiMBUT/+HzTCRAgQIAAAQIEHgKi//GzlQQIECBAgAABAmMB0T8+33QCBAgQIECAAIGHgOh//GwlAQIECBAgQIDAWED0j883nQABAgQIECBA4CEg+h8/W0mAAAECBAgQIDAWEP3j800nQIAAAQIECBB4CIj+x89WEiBAgAABAgQIjAVE//h80wkQIECAAAECBB4Cov/xs5UECBAgQIAAAQJjAdE/Pt90AgQIECBAgACBh4Dof/xsJQECBAgQIECAwFhA9I/PN50AAQIECBAgQOAhIPofP1tJgAABAgQIECAwFhD94/NNJ0CAAAECBAgQeAiI/sfPVhIgQIAAAQIECIwFRP/4fNMJECBAgAABAgQeAqL/8bOVBAgQIECAAAECYwHRPz7fdAIECBAgQIAAgYeA6H/8bCUBAgQIECBAgMBYQPSPzzedAAECBAgQIEDgISD6Hz9bSYAAAQIECBAgMBYQ/ePzTSdAgAABAgQIEHgIiP7Hz1YSIECAAAECBAiMBUT/+HzTCRAgQIAAAQIEHgKi//GzlQQIECBAgAABAmMB0T8+33QCBAgQIECAAIGHgOh//GwlAQIECBAgQIDAWED0j883nQABAgQIECBA4CEg+h8/W0mAAAECBAgQxCvXuQAADE9JREFUIDAWEP3j800nQIAAAQIECBB4CIj+x89WEiBAgAABAgQIjAVE//h80wkQIECAAAECBB4Cov/xs5UECBAgQIAAAQJjAdE/Pt90AgQIECBAgACBh4Dof/xsJQECBAgQIECAwFhA9I/PN50AAQIECBAgQOAhIPofP1tJgAABAgQIECAwFhD94/NNJ0CAAAECBAgQeAiI/sfPVhIgQIAAAQIECIwFRP/4fNMJECBAgAABAgQeAqL/8bOVBAgQIECAAAECYwHRPz7fdAIECBAgQIAAgYeA6H/8bCUBAgQIECBAgMBYQPSPzzedAAECBAgQIEDgISD6Hz9bSYAAAQIECBAgMBYQ/ePzTSdAgAABAgQIEHgIiP7Hz1YSIECAAAECBAiMBUT/+HzTCRAgQIAAAQIEHgKi//GzlQQIECBAgAABAmMB0T8+33QCBAgQIECAAIGHgOh//GwlAQIECBAgQIDAWED0j883nQABAgQIECBA4CEg+h8/W0mAAAECBAgQIDAWEP3j800nQIAAAQIECBB4CIj+x89WEiBAgAABAgQIjAVE//h80wkQIECAAAECBB4Cov/xs5UECBAgQIAAAQJjAdE/Pt90AgQIECBAgACBh4Dof/xsJQECBAgQIECAwFhA9I/PN50AAQIECBAgQOAhIPofP1tJgAABAgQIECAwFhD94/NNJ0CAAAECBAgQeAiI/sfPVhIgQIAAAQIECIwFRP/4fNMJECBAgAABAgQeAqL/8bOVBAgQIECAAAECYwHRPz7fdAIECBAgQIAAgYeA6H/8bCUBAgQIECBAgMBYQPSPzzedAAECBAgQIEDgISD6Hz9bSYAAAQIECBAgMBYQ/ePzTSdAgAABAgQIEHgIiP7Hz1YSIECAAAECBAiMBUT/+HzTCRAgQIAAAQIEHgKi//GzlQQIECBAgAABAmMB0T8+33QCBAgQIECAAIGHgOh//GwlAQIECBAgQIDAWED0j883nQABAgQIECBA4CEg+h8/W0mAAAECBAgQIDAWEP3j800nQIAAAQIECBB4CIj+x89WEiBAgAABAgQIjAVE//h80wkQIECAAAECBB4Cov/xs5UECBAgQIAAAQJjAdE/Pt90AgQIECBAgACBh4Dof/xsJQECBAgQIECAwFhA9I/PN50AAQIECBAgQOAhIPofP1tJgAABAgQIECAwFhD94/NNJ0CAAAECBAgQeAiI/sfPVhIgQIAAAQIECIwFRP/4fNMJECBAgAABAgQeAqL/8bOVBAgQIECAAAECYwHRPz7fdAIECBAgQIAAgYeA6H/8bCUBAgQIECBAgMBYQPSPzzedAAECBAgQIEDgISD6Hz9bSYAAAQIECBAgMBYQ/ePzTSdAgAABAgQIEHgIiP7Hz1YSIECAAAECBAiMBUT/+HzTCRAgQIAAAQIEHgKi//GzlQQIECBAgAABAmMB0T8+33QCBAgQIECAAIGHgOh//GwlAQIECBAgQIDAWED0j883nQABAgQIECBA4CEg+h8/W0mAAAECBAgQIDAWEP3j800nQIAAAQIECBB4CIj+x89WEiBAgAABAgQIjAVE//h80wkQIECAAAECBB4Cov/xs5UECBAgQIAAAQJjAdE/Pt90AgQIECBAgACBh4Dof/xsJQECBAgQIECAwFhA9I/PN50AAQIECBAgQOAhIPofP1tJgAABAgQIECAwFhD94/NNJ0CAAAECBAgQeAiI/sfPVhIgQIAAAQIECIwFRP/4fNMJECBAgAABAgQeAqL/8bOVBAgQIECAAAECYwHRPz7fdAIECBAgQIAAgYeA6H/8bCUBAgQIECBAgMBYQPSPzzedAAECBAgQIEDgISD6Hz9bSYAAAQIECBAgMBYQ/ePzTSdAgAABAgQIEHgIiP7Hz1YSIECAAAECBAiMBUT/+HzTCRAgQIAAAQIEHgKi//GzlQQIECBAgAABAmMB0T8+33QCBAgQIECAAIGHgOh//GwlAQIECBAgQIDAWED0j883nQABAgQIECBA4CEg+h8/W0mAAAECBAgQIDAWEP3j800nQIAAAQIECBB4CIj+x89WEiBAgAABAgQIjAVE//h80wkQIECAAAECBB4Cov/xs5UECBAgQIAAAQJjAdE/Pt90AgQIECBAgACBh4Dof/xsJQECBAgQIECAwFhA9I/PN50AAQIECBAgQOAhIPofP1tJgAABAgQIECAwFhD94/NNJ0CAAAECBAgQeAiI/sfPVhIgQIAAAQIECIwFRP/4fNMJECBAgAABAgQeAqL/8bOVBAgQIECAAAECYwHRPz7fdAIECBAgQIAAgYeA6H/8bCUBAgQIECBAgMBYQPSPzzedAAECBAgQIEDgISD6Hz9bSYAAAQIECBAgMBYQ/ePzTSdAgAABAgQIEHgIiP7Hz1YSIECAAAECBAiMBUT/+HzTCRAgQIAAAQIEHgKi//GzlQQIECBAgAABAmMB0T8+33QCBAgQIECAAIGHgOh//GwlAQIECBAgQIDAWED0j883nQABAgQIECBA4CEg+h8/W0mAAAECBAgQIDAWEP3j800nQIAAAQIECBB4CIj+x89WEiBAgAABAgQIjAVE//h80wkQIECAAAECBB4Cov/xs5UECBAgQIAAAQJjAdE/Pt90AgQIECBAgACBh4Dof/xsJQECBAgQIECAwFhA9I/PN50AAQIECBAgQOAhIPofP1tJgAABAgQIECAwFhD94/NNJ0CAAAECBAgQeAiI/sfPVhIgQIAAAQIECIwFRP/4fNMJECBAgAABAgQeAqL/8bOVBAgQIECAAAECYwHRPz7fdAIECBAgQIAAgYeA6H/8bCUBAgQIECBAgMBYQPSPzzedAAECBAgQIEDgISD6Hz9bSYAAAQIECBAgMBYQ/ePzTSdAgAABAgQIEHgIiP7Hz1YSIECAAAECBAiMBUT/+HzTCRAgQIAAAQIEHgKi//GzlQQIECBAgAABAmMB0T8+33QCBAgQIECAAIGHgOh//GwlAQIECBAgQIDAWED0j883nQABAgQIECBA4CEg+h8/W0mAAAECBAgQIDAWEP3j800nQIAAAQIECBB4CIj+x89WEiBAgAABAgQIjAVE//h80wkQIECAAAECBB4Cov/xs5UECBAgQIAAAQJjAdE/Pt90AgQIECBAgACBh4Dof/xsJQECBAgQIECAwFhA9I/PN50AAQIECBAgQOAhIPofP1tJgAABAgQIECAwFhD94/NNJ0CAAAECBAgQeAiI/sfPVhIgQIAAAQIECIwFRP/4fNMJECBAgAABAgQeAqL/8bOVBAgQIECAAAECYwHRPz7fdAIECBAgQIAAgYeA6H/8bCUBAgQIECBAgMBYQPSPzzedAAECBAgQIEDgISD6Hz9bSYAAAQIECBAgMBYQ/ePzTSdAgAABAgQIEHgIiP7Hz1YSIECAAAECBAiMBUT/+HzTCRAgQIAAAQIEHgKi//GzlQQIECBAgAABAmMB0T8+33QCBAgQIECAAIGHgOh//GwlAQIECBAgQIDAWED0j883nQABAgQIECBA4CEg+h8/W0mAAAECBAgQIDAWEP3j800nQIAAAQIECBB4CIj+x89WEiBAgAABAgQIjAVE//h80wkQIECAAAECBB4Cov/xs5UECBAgQIAAAQJjAdE/Pt90AgQIECBAgACBh4Dof/xsJQECBAgQIECAwFhA9I/PN50AAQIECBAgQOAhIPofP1tJgAABAgQIECAwFhD94/NNJ0CAAAECBAgQeAiI/sfPVhIgQIAAAQIECIwFRP/4fNMJECBAgAABAgQeAqL/8bOVBAgQIECAAAECYwHRPz7fdAIECBAgQIAAgYeA6H/8bCUBAgQIECBAgMBYQPSPzzedAAECBAgQIEDgISD6Hz9bSYAAAQIECBAgMBYQ/ePzTSdAgAABAgQIEHgIiP7Hz1YSIECAAAECBAiMBUT/+HzTCRAgQIAAAQIEHgKi//GzlQQIECBAgAABAmMB0T8+33QCBAgQIECAAIGHgOh//GwlAQIECBAgQIDAWED0j883nQABAgQIECBA4CEg+h8/W0mAAAECBAgQIDAWEP3j800nQIAAAQIECBB4CIj+x89WEiBAgAABAgQIjAVE//h80wkQIECAAAECBB4Cov/xs5UECBAgQIAAAQJjAdE/Pt90AgQIECBAgACBh4Dof/xsJQECBAgQIECAwFggMBq9VgocWkwAAAAASUVORK5CYII="></div><div data-main-rotation="0" class="textLayer" style="width: calc(var(--scale-factor) * 612px); height: calc(var(--scale-factor) * 792px);"><span role="presentation" dir="ltr" style="left: 58.27%; top: 6.31%; font-size: calc(var(--scale-factor)*11.00px); font-family: sans-serif; transform: scaleX(1.02341);">ARBA TRAVEL &amp; TOURS SDN BHD</span><br role="presentation"><span role="presentation" dir="ltr" style="left: 51.46%; top: 7.89%; font-size: calc(var(--scale-factor)*10.00px); font-family: sans-serif; transform: scaleX(0.999941);">No. Syarikat: 1093130-M No. Lesen: KPK/LN 7886</span><br role="presentation"><span role="presentation" dir="ltr" style="left: 51.5%; top: 9.34%; font-size: calc(var(--scale-factor)*10.00px); font-family: sans-serif; transform: scaleX(0.999935);">K-3-01, Conezion, Persiaran IRC3, IOI Resort City,</span><br role="presentation"><span role="presentation" dir="ltr" style="left: 66.93%; top: 10.79%; font-size: calc(var(--scale-factor)*10.00px); font-family: sans-serif; transform: scaleX(0.999949);">62502, Putrajaya, MALAYSIA</span><br role="presentation"><span role="presentation" dir="ltr" style="left: 51.49%; top: 12.25%; font-size: calc(var(--scale-factor)*10.00px); font-family: sans-serif; transform: scaleX(0.999951);">Tel: +603-8687 4950</span><span role="presentation" dir="ltr" style="left: 66.43%; top: 12.25%; font-size: calc(var(--scale-factor)*10.00px); font-family: sans-serif;"> </span><span role="presentation" dir="ltr" style="left: 69.15%; top: 12.25%; font-size: calc(var(--scale-factor)*10.00px); font-family: sans-serif; transform: scaleX(0.999959);">Email: cs@arbatravel.com</span><br role="presentation"><span role="presentation" dir="ltr" style="left: 35.12%; top: 17.19%; font-size: calc(var(--scale-factor)*16.00px); font-family: sans-serif; transform: scaleX(1.08787);">Trip Confirmation Letter</span><br role="presentation"><span role="presentation" dir="ltr" style="left: 11.75%; top: 22.19%; font-size: calc(var(--scale-factor)*10.00px); font-family: sans-serif; transform: scaleX(0.999953);">Our Ref:${referenceNumber}</span><span role="presentation" dir="ltr" style="left: 29.7%; top: 22.19%; font-size: calc(var(--scale-factor)*10.00px); font-family: sans-serif;"> </span><span role="presentation" dir="ltr" style="left: 74.48%; top: 22.19%; font-size: calc(var(--scale-factor)*10.00px); font-family: sans-serif; transform: scaleX(0.999959);">Date: ${today}</span><br role="presentation"><span role="presentation" dir="ltr" style="left: 11.76%; top: 26.46%; font-size: calc(var(--scale-factor)*10.00px); font-family: sans-serif; transform: scaleX(0.999937);">To whom it may concern,</span><br role="presentation"><span role="presentation" dir="ltr" style="left: 11.76%; top: 29.98%; font-size: calc(var(--scale-factor)*11.00px); font-family: sans-serif; transform: scaleX(1.01068);">SUBJECT: TRIP CONFIRMATION FOR OUR VALUED CUSTOMER</span><br role="presentation"><span role="presentation" dir="ltr" style="left: 11.76%; top: 33.64%; font-size: calc(var(--scale-factor)*10.00px); font-family: sans-serif; transform: scaleX(1.0064);">This letter acts as a confirmation for our valued customer to inform you that the following customer will be</span><br role="presentation"><span role="presentation" dir="ltr" style="left: 11.76%; top: 35.31%; font-size: calc(var(--scale-factor)*10.00px); font-family: sans-serif; transform: scaleX(0.99994);">joining our travel trip to ${destination} from ${departureFlightDate} to ${returnFlightDate}</span><br role="presentation">
             <span role="presentation" dir="ltr" style="left: 12.13%; top: 39.19%; font-size: calc(var(--scale-factor)*10.00px); font-family: sans-serif; transform: scaleX(1.02106);">Customer Name, ID and Pax</span>
             <br role="presentation">
             <span role="presentation" dir="ltr" style="left: 12.13%; top: 41.31%; font-size: calc(var(--scale-factor)*10.00px); font-family: sans-serif; transform: scaleX(0.999947);">${customerName} - ${customerID}</span>
             <span role="presentation" dir="ltr" style="left: 12.13%; top: 42.81%; font-size: calc(var(--scale-factor)*10.00px); font-family: sans-serif; transform: scaleX(0.999947);">Pax : ${pax}</span>
             <br role="presentation"><span role="presentation" dir="ltr" style="left: 11.76%; top: 46.71%; font-size: calc(var(--scale-factor)*11.00px); font-family: sans-serif; transform: scaleX(1.10574);">Flight itinerary</span><br role="presentation">
             <span role="presentation" dir="ltr" style="left: 11.76%; top: 48.53%; font-size: calc(var(--scale-factor)*10.00px); font-family: sans-serif; transform: scaleX(1.02795);">Kindly be advised that the flight ticket has been booked through the group booking system, thus we are</span>
             <br role="presentation">
             <span role="presentation" dir="ltr" style="left: 11.76%; top: 50.2%; font-size: calc(var(--scale-factor)*10.00px); font-family: sans-serif; transform: scaleX(0.999935);">unable to issue an e-ticket for the mentioned names. Flight details are shown as in the table below:</span>
             <br role="presentation">
             <span role="presentation" dir="ltr" style="left: 12.62%; top: 54.47%; font-size: calc(var(--scale-factor)*10.00px); font-family: sans-serif; transform: scaleX(0.999951);">DEPARTURE FLIGHT</span>
             <br role="presentation"><span role="presentation" dir="ltr" style="left: 12.62%; top: 57.34%; font-size: calc(var(--scale-factor)*10.00px); font-family: sans-serif; transform: scaleX(0.999961);">RETURN FLIGHT</span>
             <br role="presentation"><span role="presentation" dir="ltr" style="left: 12.26%; top: 61.4%; font-size: calc(var(--scale-factor)*11.00px); font-family: sans-serif; transform: scaleX(1.08416);">Accommodation Details</span>
             <br role="presentation"><span role="presentation" dir="ltr" style="left: 12.01%; top: 64.86%; font-size: calc(var(--scale-factor)*10.00px); font-family: sans-serif; transform: scaleX(1.03777);">Name: ${AccommodationName == null ? "Default" : AccommodationName}</span><br role="presentation"><span role="presentation" dir="ltr" style="left: 12.01%; top: 66.79%; font-size: calc(var(--scale-factor)*10.00px); font-family: sans-serif; transform: scaleX(1.09832);">Address: ${AccommodationAddress == null ? "Default" : AccommodationAddress}</span><br role="presentation"><span role="presentation" dir="ltr" style="left: 11.76%; top: 71.17%; font-size: calc(var(--scale-factor)*10.00px); font-family: sans-serif; transform: scaleX(1.11389);">Disclaimer: The flight and accommodation details are based on ARBA Travels’ default booking.</span><br role="presentation"><span role="presentation" dir="ltr" style="left: 11.76%; top: 72.84%; font-size: calc(var(--scale-factor)*10.00px); font-family: sans-serif; transform: scaleX(1.07905);">Any changes or cancellations will be confirmed at least 2 weeks before the trip departs.</span><br role="presentation"><span role="presentation" dir="ltr" style="left: 11.76%; top: 76.35%; font-size: calc(var(--scale-factor)*10.00px); font-family: sans-serif; transform: scaleX(0.999936);">We thank you for your consideration and kind attention.</span><br role="presentation"><span role="presentation" dir="ltr" style="left: 11.76%; top: 81.71%; font-size: calc(var(--scale-factor)*11.00px); font-family: sans-serif; transform: scaleX(1.09038);">Yours sincerely,</span><br role="presentation"><span role="presentation" dir="ltr" style="left: 11.76%; top: 83.54%; font-size: calc(var(--scale-factor)*11.00px); font-family: sans-serif; transform: scaleX(0.999733);">ARBA Travel &amp; Tours Sdn. Bhd.</span><br role="presentation"><span role="presentation" dir="ltr" style="left: 11.76%; top: 85.33%; font-size: calc(var(--scale-factor)*8.00px); font-family: sans-serif; transform: scaleX(0.998398);">This document is computer-generated. No signature is required</span><br role="presentation"><span role="presentation" dir="ltr" style="left: 31.67%; top: 54.33%; font-size: calc(var(--scale-factor)*9.00px); font-family: monospace; transform: scaleX(1.09149);">${departureFlightCode}</span><span role="presentation" dir="ltr" style="left: 37.84%; top: 54.33%; font-size: calc(var(--scale-factor)*9.00px); font-family: monospace;"> </span><span role="presentation" dir="ltr" style="left: 38.73%; top: 54.33%; font-size: calc(var(--scale-factor)*9.00px); font-family: monospace; transform: scaleX(1.09149);"></span><br role="presentation"><span role="presentation" dir="ltr" style="left: 31.96%; top: 57.37%; font-size: calc(var(--scale-factor)*9.00px); font-family: monospace; transform: scaleX(1.09149);">${returnFlightCode}</span><span role="presentation" dir="ltr" style="left: 38.14%; top: 57.37%; font-size: calc(var(--scale-factor)*9.00px); font-family: monospace;"> </span><span role="presentation" dir="ltr" style="left: 39.02%; top: 57.37%; font-size: calc(var(--scale-factor)*9.00px); font-family: monospace; transform: scaleX(1.09149);"></span><br role="presentation"><span role="presentation" dir="ltr" style="left: 63.02%; top: 54.48%; font-size: calc(var(--scale-factor)*9.00px); font-family: monospace; transform: scaleX(1.09149);">${departureFlightDate}</span><br role="presentation"><span role="presentation" dir="ltr" style="left: 63.02%; top: 57.29%; font-size: calc(var(--scale-factor)*9.00px); font-family: monospace; transform: scaleX(1.09149);">${returnFlightDate}</span></div></div></div>
         </body>
     </html>
 `);

    pdfWindow.document.close();

    // Save the PDF as a file
    pdfWindow.print();
  };

  return (
    <div style={{ textAlign: "center" }}>
      <header
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          backgroundColor: "red",
          padding: "20px",
        }}
      >
        <img
          src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_2872/https://arbatravel.com/wp-content/uploads/2019/12/ARBA-Travel-Logo-optimized.png"
          alt="ARBA Logo"
          style={{ width: "100px", marginRight: "10px" }}
        />
      </header>

      <div
        style={{
          backgroundColor: "#f5f5f5",
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
          borderRadius: "8px",
          padding: "20px",
          paddingTop: "20px",
          width: window.innerWidth < 500 ? "300px" : "500px",
          margin: "0 auto",
          marginTop: "20px",
        }}
      >
        <span style={{ color: "red", fontWeight: "500"}}>Hello ! This is your</span>
        <br/>
        <span style={{ fontSize: window.innerWidth < 500 ? "24px":"40px", fontWeight: "bold", color:"#41424C" }}>
          TRIP CONFIRMATION
        </span>
      </div>
      {(customerID == "" || customerID == null) && (
        <div
          style={{
            backgroundColor: "#f5f5f5",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            borderRadius: "8px",
            padding: "20px",
            paddingTop: "20px",
            width: "300px",
            margin: "0 auto",
            marginTop: "20px",
          }}
        >
          <span style={{ fontSize: 14 }}>
            <span style={{ color: "red", fontWeight: "bold" }}>
              Something went wrong.{" "}
            </span>
            Please use inside
          </span>
          <br />
          <button
            style={{
              marginTop: "5px",
              padding: "10px 20px",
              fontSize: "16px",
              backgroundColor: "#007bff",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
            onClick={() => window.open("https://customer.arbatravel.com")}
          >
            customer.arbatravel.com
          </button>
          <br />
          <span style={{ fontSize: 14 }}>or contact us.</span>
        </div>
      )}

      <input
        style={{
          marginTop: "10px",
          padding: "10px 20px",
          fontSize: "16px",
          border: "1px solid #ccc",
          borderRadius: "4px",
          width: "300px",
        }}
        type="text"
        value={search}
        onChange={(e) => handleSearch(e)}
        placeholder="Search by Name"
      ></input>

      {customerData.length > 0 ? (
        customerTempData.map((customer) => (
          <div
            style={{
              backgroundColor: "#f5f5f5",
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
              borderRadius: "8px",
              padding: "20px",
              paddingTop: "20px",
              width: "300px",
              margin: "0 auto",
              marginTop: "20px",
            }}
          >
            <p style={{ fontSize: "16px", alignItems: "left", display:"flex", flexDirection: "column", textAlign: "left" }}>
              
              Customer Name : <br /> <b>{customer.json.Full_Name}</b>
              <br />
              Destination : <br /> <b>{tripData.destination}</b>
              <br />
              Customer ID : <br /> <b>{customer.json.Fresh_custid}</b>
              <br />
              Trip ID :<br /> <b>{tripData.tripID}</b>
              <br />
            </p>

            <p style={{ fontSize: "16px" }}>
              Generate your Trip Confirmation PDF
            </p>

            <button
              style={{
                padding: "10px 20px",
                fontSize: "16px",
                backgroundColor: "#007bff",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
              }}
              onClick={() =>
                handleDownload(
                  customer.json.Fresh_custid,
                  customer.json.Full_Name,
                  tripData.departdate,
                  tripData.departCode,
                  tripData.returnCode,
                  tripData.returndate,
                  tripData.hotel_addr,
                  tripData.accommodation,
                  tripData.destination,
                  customerData.length,
                  customer.json.id,
                )
              }
            >
              Download
            </button>
          </div>
        ))
      ) : (
        // email,customerName, customerID, departureFlightDate, departureFlightCode, returnFlightCode, returnFlightDate, AccommodationAddress, AccommodationName, destination, pax, referenceNumber
        <div
          style={{
            alignContent: "center",
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <DotLoader color="red" size={150} aria-label="loading spinner" />
          <span style={{ marginTop: 30, fontSize: 20 }}>Loading...</span>
        </div>
      )}
      <br />
      <small style={{ fontSize: 10, marginBottom: "20px" }}>Supported: Chrome, Firefox, Safari</small>
      <br/>
      <br/>
      <br/>
      <br/>
      <footer style={{ position: "fixed", bottom: 0, width: "100%" }}>
        <div style={{ backgroundColor: "#f5f5f5", padding: "10px", textAlign: "center" }}>
            <a href="https://arbatravel.com/hubungi/" style={{ textDecoration: "none" }}>Contact Us</a> | <a href="https://customer.arbatravel.com" style={{ textDecoration: "none" }}>Client Area</a>
        </div>
      </footer>
    </div>
  );
}
